var globalFrameIDForTextToAlign = null;   
         var currentFrameID = null;  
         var currentElementID = null;  
         var StrapCurrentFrame = null;
         var StrapCurrentFrameBoundingBox = null;
         var NormalImagesCurrentFrameBoundingBox = null;  
         var frameJson = [];  
         var frameId = null;         
         var fonts = null;
         var fonts_order = null;
         var text_color = null;
         var text_size = null;
         var text_border_color = null;  
         var custom_font_css = null;    
         var icons = null;
         var flags = null;
         var designsProductJSON = null;
         var boundingBoxJSON = null;
         
         var flagBoundingBoxJSON = null;

         var check_previous_saved_setting = null;  
         var max_image_size = null;
         var max_character_allowed = null;
         var max_text_layer_allowed = null;
         var max_image_allowed = null;
         var straps_data = null;
         var image_template_width = null;
         var image_template_height = null;

        // price for character and type 
         var text_price = 0;
         var text_price_type = null;
           
        // price for image and type
           
         var image_price = 0;
         var image_price_type = null;   

        //strap code start
         var sstrap_price = 0;
         var sstrap_name = "";
         //strap code end
           
        // variant price
         var variant_price = 0;  
           
        // total price calculation
        var total_price = 0;
           
        //price array
        var price_array = new Array();   
           
        // fetch custom design for selected variant
        var strap_position = "";
        var editor_mode_hide = "";
        var text_position = "";
        var textBoundingBoxMode = "";
        var textBoundingBox = {};
        var text_alignment = ""; 

        // prj code
        var fixed_text = "";
        var fixed_text_color = "";
        var fixed_text_border_color = "";
        var fixed_text_no_of_letters ="";
        var fixed_text_font_family ="";
        var fixed_text_ipod = "";
         //end

        var file_uploade_hide ="";
        var fpdInitialized = false;
        var isCustomizerInitialized = false;

function getCurrentVariantTitle() {
    let variantTitle = ""; //18012026 added

    // Prefer resolving via the actual selected variant ID + Shopify's own
    // variant JSON — this always returns the full "Color / Strap Belt"
    // title regardless of whether options are rendered as <select>
    // dropdowns or swatches/radios.
    var currentId = (typeof getCurrentVariantId === 'function') ? getCurrentVariantId() : null;
    if (currentId) {
        var scripts = document.querySelectorAll('script[type="application/json"]');
        for (var s = 0; s < scripts.length; s++) {
            try {
                var data = JSON.parse(scripts[s].textContent);
                if (Array.isArray(data)) {
                    for (var v = 0; v < data.length; v++) {
                        if (data[v] && String(data[v].id) === String(currentId) && data[v].title) {
                            variantTitle = data[v].title;
                            break;
                        }
                    }
                }
            } catch (e) { /* ignore non-variant JSON blocks */ }
            if (variantTitle) break;
        }
    }

    // Fallback: rebuild from DOM controls, capturing BOTH <select> dropdowns
    // AND swatch/radio-style options (Color is rendered as swatches, not a
    // <select>, so it was being skipped before).
    if (!variantTitle) {
        var variantSelectsContainer = document.querySelector('variant-selects:not([data-sticky])');
        if (!variantSelectsContainer) {
            // Fallback: if no non-sticky exists, use the first one
            variantSelectsContainer = document.querySelector('variant-selects');
        }

        if (variantSelectsContainer) {
            var titleParts = [];
            var fieldsets = variantSelectsContainer.querySelectorAll('fieldset, .product-form__input');
            if (fieldsets.length > 0) {
                // Iterate in DOM order so option order (e.g. Color then
                // Strap Belt) is preserved regardless of whether each is a
                // <select> or a swatch/radio group.
                fieldsets.forEach(function(fieldset) {
                    var select = fieldset.querySelector('select.select__select');
                    if (select) {
                        var selectedOption = select.options[select.selectedIndex];
                        if (selectedOption && selectedOption.value) {
                            titleParts.push(selectedOption.value);
                        }
                        return;
                    }
                    var checkedInput = fieldset.querySelector('input[type="radio"]:checked');
                    if (checkedInput && checkedInput.value) {
                        titleParts.push(checkedInput.value);
                    }
                });
            } else {
                variantSelectsContainer.querySelectorAll('select.select__select').forEach(function(select) {
                    var selectedOption = select.options[select.selectedIndex];
                    if (selectedOption && selectedOption.value) titleParts.push(selectedOption.value);
                });
                variantSelectsContainer.querySelectorAll('input[type="radio"]:checked').forEach(function(input) {
                    if (input.value) titleParts.push(input.value);
                });
            }
            variantTitle = titleParts.join(' / ');
        }
    }

    //console.log('Current variant title:', variantTitle);
    return variantTitle;
}

function getCurrentVariantId() {
    var variantId = null;
    var urlParams = new URLSearchParams(window.location.search);
    variantId = urlParams.get('variant');
    if (!variantId) variantId = $("#ProductSelect-product-template").val();
    if (!variantId) {
        var productVariantInput = $('input[name="id"].product-variant-id');
        if (productVariantInput.length) variantId = productVariantInput.val();
    }
    if (!variantId) {
        var formVariantInput = $('form[action*="/cart/add"] input[name="id"]');
        if (formVariantInput.length) variantId = formVariantInput.val();
    }
    if (!variantId) {
        var selectedVariant = $('input[name="id"]:checked, select[name="id"]');
        if (selectedVariant.length) variantId = selectedVariant.val();
    }
    //console.log('Detected variant ID:', variantId);
    return variantId;
}

function updateCustomizePrice() {
    var priceElement = $('[data-product-price], .product-price, #variant-price, [itemprop="price"]').first();
    var priceText = priceElement.text().trim();
    $("#final_customize_price").text(priceText);
    var price = priceText.replace(/[^0-9.,]/g, '');
    if (price) variant_price = parseFloat(price);
}

// NEW FUNCTION TO RELOAD CUSTOMIZER WITH NEW VARIANT
function reloadCustomizerWithVariant(variantId) {
    //console.log('Reloading customizer with variant:', variantId);
    
    // Reset the initialization flag
    isCustomizerInitialized = false;
    
    // Clear the designer instance
    if (window.yourDesigner) {
        try {
            // Destroy the existing instance
            $('#clothing-designer').empty();
            window.yourDesigner = null;
        } catch(e) {
            //console.log('Error destroying designer:', e);
        }
    }
    
    // Load new settings and reinitialize
    get_custom_design_settings(variantId);
    
    // Wait a bit for settings to load, then reload if modal is open
    setTimeout(function() {
        if ($(".mainPopup").is(':visible')) {
            load_product_customzier();
            isCustomizerInitialized = true;
        }
    }, 500);
}

        function get_custom_design_settings(variant_id)
        {
                           // Ensure ip_address and customer_id are defined
                           if (typeof ip_address === 'undefined') {
                               window.ip_address = '';
                           }
                           if (typeof customer_id === 'undefined') {
                               window.customer_id = '';
                           }
                           
                           // Validate variant_id
                           if (!variant_id) {
                               console.warn('get_custom_design_settings: variant_id is empty or undefined');
                               variant_id = '';
                           }
                           
                           console.log('Making API call with:', {
                               variant_id: variant_id,
                               ip_address: ip_address || '',
                               customer_id: customer_id || ''
                           });
                           
                           $.ajax({
                                url       : "https://conceptodohaapp.com/concepto_version2/fetch_customize_settings",
                                //url:"https://conceptodohaapp.com/fetch_customize_settings",
                                type      : "POST",
                                crossDomain : true,
                                async       : true,
                                cache       : false,
                                dataType    : 'json',
                                //data      : { 'variant_id' : variant_id},
                                data      : { 
                                    'variant_id' : String(variant_id || ''),
                                    'ip_address' : String(ip_address || ''),
                                    'customer_id' : String(customer_id || '')
                                },
                                success: function (result) {
                                    //console.log('API Response:', result);
                                    
                                    if(result && result.success == true) {
                                        // Store all your settings first
                                        text_position = result.text_position;
                                        editor_mode_hide = result.editor_mode_hide; 
                                        strap_position = result.strap_position;
                                        file_uploade_hide = result.file_uploade_hide;

                                        fonts = result.google_fonts;
                                        fonts_order = JSON.parse(JSON.stringify(result.google_fonts));
                                        
                                        // ADD THESE DEBUG LINES HERE ↓
                                        //console.log("fixed_text_font_family:", result.fixed_text_font_family);
                                        //console.log("All fonts loaded:", result.google_fonts);
                                        //console.log("fixed_text value:", result.fixed_text);
                                        
                                        // Initially show the button (API says customization is available)
                                        //$(".customizer_button").show();
                                        //$(".custom_buy_now_btn").show();
                                        checkLocationInventoryAndShowButton(variant_id);
                                        
                                        icons = result.icon;
                                        
                                        if(editormode_chk()) {
                                            var tempicons = new Array();
                                            for(i=0; i< icons.length; i++){
                                                if(icons[i].image_category != "Painting"){
                                                    tempicons.push(icons[i]);
                                                }
                                            }
                                            icons = tempicons;
                                        }

                                        
                                        flags = result.flag;
                                        
                                        if(editormode_chk121()) {
                                            var tempflags = new Array();
                                            for(i=0; i< flags.length; i++){
                                                if(flags[i].image_category != "Flags"){
                                                    tempflags.push(flags[i]);
                                                }
                                            }
                                            flags = tempflags;
                                            //console.log("Flags after filter:", flags.length);
                                        }
                                        
                                        straps_data = result.straps_data;
                                        
                                        if (result.sstrap_price && result.sstrap_name) {
                                            sstrap_price = result.sstrap_price;
                                            sstrap_name = result.sstrap_name;
                                            //console.log("Strap to charge for:", sstrap_name, "Price:", sstrap_price);
                                        }
                                        
                                        fonts = result.google_fonts;
                                        fonts_order = JSON.parse(JSON.stringify(result.google_fonts));
                                        text_color = result.text_color;
                                        text_size = result.text_size;
                                        text_border_color = result.text_border_color;
                                        custom_font_css = result.custom_font_css;
                                        
                                        max_image_size = result.image_setting.max_image_size;
                                        max_image_allowed = result.image_setting.max_image_allowed;
                                        max_character_allowed = result.character_setting.max_character_allowed;
                                        
                                        image_template_width = result.image_template_width;
                                        image_template_height = result.image_template_height;
                                        
                                        text_price = result.character_setting.text_price;
                                        text_price_type = result.character_setting.price_type;
                                        max_text_layer_allowed = result.character_setting.max_text_layer_allowed;
                                        
                                        image_price = result.image_setting.image_price;
                                        image_price_type = result.image_setting.price_type;
                                        
                                        price_text = $("#variant-price").text();
                                        variant_price = parseFloat(price_text);
                                        
                                        $("#final_customize_price").text($("#variant-price").text());
                                        designsProductJSON = result.product_design;
                                        boundingBoxJSON = {
                                            "width": parseInt(result.permissible_area.width),
                                            "height": parseInt(result.permissible_area.height),
                                            "y": parseInt(result.permissible_area.y_axis),
                                            "x": parseInt(result.permissible_area.x_axis)
                                        };

                                        // ← ADD THIS RIGHT AFTER
                                        var flagPadding = 15; // adjust this number to increase/decrease padding
                                        flagBoundingBoxJSON = {
                                            "width": boundingBoxJSON.width - (flagPadding * 2),
                                            "height": boundingBoxJSON.height - (flagPadding * 2),
                                            "y": boundingBoxJSON.y + flagPadding,
                                            "x": boundingBoxJSON.x + flagPadding

                                        };
                                        
                                        if(result.fixed_text) {
                                            fixed_text = result.fixed_text;
                                            fixed_text_color = result.fixed_text_color;
                                            fixed_text_border_color = result.fixed_text_border_color;
                                            fixed_text_no_of_letters = result.fixed_text_no_of_letters;
                                            fixed_text_font_family = result.fixed_text_font_family;
                                        }
                                        
                                        if(result.fixed_text_ipod == "yes") {
                                            fixed_text_ipod = result.fixed_text_ipod;
                                        }
                                        
                                        check_previous_saved_setting = result.check_previous_saved_setting;
                                        
                                        // ⭐ CRITICAL: Check availability AFTER all settings are stored
                                        //  Check for sold-out price class
                                        if($(".price--sold-out").length > 0) {
                                            //console.log("Hide custom button soldout");
                                            $(".customizer_button").hide();
                                            $(".custom_buy_now_btn").hide();
                                        }
                                        
                                        
                                    } else {
                                        // Product doesn't support customization
                                        $(".customizer_button").hide();
                                        
                                        // Still check if buy now button should show
                                        var mainButton = document.querySelector('[id^="ProductSubmitButton-"]');
                                        if (mainButton && mainButton.hasAttribute('disabled')) {
                                            $(".custom_buy_now_btn").hide();
                                        } else if ($(".single_add_to_cart_button").attr('disabled') !== undefined) {
                                            $(".custom_buy_now_btn").hide();
                                        } else {
                                            $(".custom_buy_now_btn").show();
                                        }
                                        
                                        check_previous_saved_setting = null;
                                    }
                                },
                                error: function(xhr, status, error) {
                                    //console.error('API Error:', status, error);
                                    //console.warn('Using default customization settings due to API failure');
                                    
                                    // Set defaults...
                                    fonts = [];
                                    fonts_order = [];
                                    text_color = [
                                        {color_code: '#000000'},
                                        {color_code: '#ffffff'},
                                        {color_code: '#ff0000'},
                                        {color_code: '#0000ff'}
                                    ];
                                    text_border_color = [
                                        {color_code: '#000000'},
                                        {color_code: '#ffffff'}
                                    ];
                                    text_size = [
                                        {size: 20},
                                        {size: 30},
                                        {size: 45},
                                        {size: 60}
                                    ];
                                    custom_font_css = [];
                                    icons = [];
                                    straps_data = [];
                                    designsProductJSON = [];
                                    boundingBoxJSON = {"width": 200,"height": 200,"y": 50,"x": 50};
                                    
                                    // Show buttons for testing, but still respect sold out state
                                    $(".customizer_button").show();
                                    $(".custom_buy_now_btn").show();
                                    
                                    // Check availability even on error
                                    if($(".price--unavailable").length > 0 || $(".price--sold-out").length > 0) {
                                        $(".customizer_button").hide();
                                    }
                                    
                                    var mainButton = document.querySelector('[id^="ProductSubmitButton-"]');
                                    if (mainButton && mainButton.hasAttribute('disabled')) {
                                        $(".customizer_button").hide();
                                        $(".custom_buy_now_btn").hide();
                                    }
                                },
                                complete    : function(result1) {
                                }
                            }); 
          
                             }

                    function openCity(evt, cityName) {
                        var i, tabcontent, tablinks;
                        tabcontent = document.getElementsByClassName("tabcontent");
                        for (i = 0; i < tabcontent.length; i++) {
                            tabcontent[i].style.display = "none";
                        }
                        tablinks = document.getElementsByClassName("tablinks");
                        for (i = 0; i < tablinks.length; i++) {
                            tablinks[i].className = tablinks[i].className.replace(" active", "");
                        }
                        document.getElementById(cityName).style.display = "block";
                        evt.currentTarget.className += " active";
                    }

                    // Get the element with id="defaultOpen" and click on it
                    //document.getElementById("defaultOpen").click();


                    // to show and hide .mainPopup modal

$(document).ready(function () {
    $('.fpd-list-row').removeClass('fpd-locked');
    if(editormode_chk()){
        jQuery('.custom-image-upload').remove();
    }

    // GET INITIAL VARIANT ID
    var variant_id = getCurrentVariantId();
    //console.log('Initial variant_id:', variant_id);
    get_custom_design_settings(variant_id);

    // LISTEN FOR VARIANT CHANGES
    $(document).on('change', 'select[name="id"], input[name="id"], #ProductSelect-product-template', function() {
        var newVariantId = $(this).val();
        //console.log('Variant changed:', newVariantId);
        if (newVariantId) {
            get_custom_design_settings(newVariantId);
            updateCustomizePrice();
            
            // If customizer modal is open, reload it with new variant
            if ($(".mainPopup").is(':visible')) {
                reloadCustomizerWithVariant(newVariantId);
            }
        }
    });

    var lastUrl = window.location.href;
    setInterval(function() {
        if (lastUrl !== window.location.href) {
            lastUrl = window.location.href;
            var newVariantId = getCurrentVariantId();
            if (newVariantId) {
                //console.log('Variant changed (URL):', newVariantId);
                get_custom_design_settings(newVariantId);
                updateCustomizePrice();
                
                // If customizer modal is open, reload it with new variant
                if ($(".mainPopup").is(':visible')) {
                    reloadCustomizerWithVariant(newVariantId);
                }
            }
        }
    }, 500);

    $(document).on('click', '[data-variant-id], .variant-option, .swatch-element, .product-form__input input, .product-form__input label', function() {
        setTimeout(function() {
            var newVariantId = getCurrentVariantId();
            if (newVariantId) {
                //console.log('Variant changed (click):', newVariantId);
                get_custom_design_settings(newVariantId);
                updateCustomizePrice();
                
                // If customizer modal is open, reload it with new variant
                if ($(".mainPopup").is(':visible')) {
                    reloadCustomizerWithVariant(newVariantId);
                }
            }
        }, 300);
    });
    
    // CUSTOMIZE BUTTON CLICK
    $(document).on("click", ".customizer_button", function () {
        
        var latestVariantId = getCurrentVariantId();
        if (latestVariantId) {
            //console.log('Opening customizer with variant:', latestVariantId);
            
            // Make sure we have the latest settings before opening
            get_custom_design_settings(latestVariantId);
            
            // Wait a bit for settings to load
            setTimeout(function() {
                $(".mainPopup").css("display", "flex");
                $(".fpd-controls").show();
                $("body").css("overflow", "hidden");
                if($(window).width() < 750) {
                    //console.log("Window < "+$(window).width());          
                    $("body").addClass("bodyScrollEdreamz");
                }
                // **FIX: Only initialize if not already initialized**
            if (!isCustomizerInitialized) {
                load_product_customzier();
                isCustomizerInitialized = true;
            }
                setTimeout( function() { editormode_chk1(); }, 3000);
            }, 300);
        } else {
            // Fallback if no variant detected
            $(".mainPopup").css("display", "flex");
            $(".fpd-controls").show();
            $("body").css("overflow", "hidden");
            if($(window).width() < 750) {
                //console.log("Window < "+$(window).width());          
                $("body").addClass("bodyScrollEdreamz");
            }
            // **FIX: Only initialize if not already initialized**
        if (!isCustomizerInitialized) {
            load_product_customzier();
            isCustomizerInitialized = true;
        }
            setTimeout( function() { editormode_chk1(); }, 3000);
        }
    });
    
    $(document).on("click", ".close", function (e) {
        $(".mainPopup").hide();
         $("body").removeClass("bodyScrollEdreamz");
         // **FIX: Reset the flag when closing**
    isCustomizerInitialized = false;
    
    // **FIX: Clear the designer instance**
    if (window.yourDesigner) {
        $('#clothing-designer').empty();
        window.yourDesigner = null;
    }
         location.reload();
    });
    
    $('.mainPopup').on('click', '#add-custom-image-btn', function(e){
        if($('.image-upload-item:visible').length + 1 > max_image_allowed){
            alert("User can not upload more than "+max_image_allowed+" images");
            return;
        }
        $('.custom-image-container').append($('.image-upload-item:first').clone());
    }) 
    
    $('.mainPopup').on('click', '.add-more-text-element', function(e){
        e.stopPropagation();
        if($('.input-text-element').length > max_text_layer_allowed){
            alert('User can not add more than '+max_text_layer_allowed+' text element');
            return;
        }
        
        $('.border-picker').removeClass("active-border-color-element");
        $('.color-picker').removeClass("active-color-element");
        
        insert_text_html_element($(this));
    })  
    
    $('.mainPopup').on('change', '.text-alignent-radio', function(e){
        
        //console.log("currentelementId==>",currentelementId);
        //console.log("globalFrameIDForTextToAlign==>",globalFrameIDForTextToAlign);
        
        //console.log('text-alignent-radio - '+$(this).val());
        
        if (!yourDesigner || !yourDesigner.currentViewInstance) {
            console.warn('FancyProductDesigner not initialized yet');
            return;
        }
        
        var currentelement = yourDesigner.currentViewInstance.getElementByID(globalFrameIDForTextToAlign);         
        
        var element_value = $(this).val();	
        obj = render_allignment(element_value, currentelement);
        obj['custom_text_allignment'] = element_value;
        
        var element = yourDesigner.currentViewInstance.setElementParameters(obj, currentelement);                     
    })          
    
    $('.mainPopup').on('change', '.custom-font-css', function(e){
        
        var currentelement = yourDesigner.currentViewInstance.getElementByID(currentelementId);         
        
        var element_value = $(this).val();
        var search_custom_css = getDetailsByAttr(custom_font_css, 'id', element_value);
        search_custom_css.custom_css = search_custom_css.id;
        
        delete search_custom_css.id;
        delete search_custom_css.name;
        
        //console.log(search_custom_css, element_value);
        var element = yourDesigner.currentViewInstance.setElementParameters(search_custom_css[0], currentelement);                      
    })          
});

           
           
            function render_allignment(element_value, currentelement) {
                var obj = {};
                obj['title'] = currentelement.original_text;
                obj['textAlign'] = 'center';
                obj['originX'] = 'center';
                obj['originY'] = 'center';
                obj['lineHeight'] = 1.0;        // ADD THIS LINE - Equal spacing for vertical text

                if (element_value === "Horizontal") {
                    obj['text'] = currentelement.original_text;
                } else {
                    obj['text'] = chunk(currentelement.original_text, 1);
                }

                return obj;
            }

                    var flag = 0;
                    var elementIdArr = [] ;
                    var currentelementId = "";
                    var click_bind = 0;

$(document).on('init', '.slick-slider', function () {
    setTimeout(function () {
        $('.slick-slide h3:contains("Painting")').text('PAINTINGS');
        $('.slick-slide h3:contains("Strap")').text('STRAPS');
        $('.slick-slide h3:contains("Flags")').text('FLAGS');
    }, 100);
});
 function load_product_customzier() {
    
    var allDesigns = [];
    if (icons && icons.length > 0) allDesigns = allDesigns.concat(icons);
    //if (flags && flags.length > 0) allDesigns = allDesigns.concat(flags);

    //console.log("Icons count:", icons ? icons.length : 0);
    //console.log("Flags count:", flags ? flags.length : 0);

     var $yourDesigner = $('#clothing-designer'),
         pluginOpts = {
             productsJSON: designsProductJSON, 
             designsJSON: allDesigns,  
             strapsJSON: straps_data, 
             stageWidth: image_template_width,
             stageHeight: image_template_height,
             editorMode: false,
             smartGuides: true,
             elementParameters: {
                padding: 0           // ← ADD THIS — applies globally to all elements
             },
             initialActiveModule: "text",
             mainBarModules: ['text', 'designs', 'manage-layers'],
             fonts: fonts,
             boundingBox: boundingBoxJSON,
             boundingBoxMode: 'limitModify',
             customTextParameters: {
                 colors: true,
                 color: "#FFFFFF",
                 removable: false,
                 resizable: true,
                 draggable: true,
                 rotatable: true,
                 autoCenter: true,
                 boundingBox: "Base",
                 curvable: true,
                 topped: true,
                 "boundingBoxMode": "limitModify",
                 boundingBox: boundingBoxJSON
             },
             customImageParameters: {
                 draggable: true,
                 removable: true,
                 resizable: true,
                 rotatable: true,
                 copyable: false,
                 colors: '#000',
                 autoCenter: true,
                 padding: 0,
                 "boundingBoxMode": "limitModify",
                 "boundingBox": boundingBoxJSON,
             },
             actions: {

             }
         };

     yourDesigner = new FancyProductDesigner($yourDesigner, pluginOpts);

     $yourDesigner.on('elementAdd', function(evt, fabricObject) {
        //console.log('fabricObject ',fabricObject);

        // ← ADD THIS BLOCK AT THE VERY TOP
        if (fabricObject.custom_type === "image" && fabricObject.image_category === "Flags") {
            setTimeout(function() {
                var canvas = fabricObject.canvas;
                if (!canvas) return;

                var imgElement = fabricObject._element;
                if (!imgElement) return;

                var tempCanvas = document.createElement('canvas');
                var ctx = tempCanvas.getContext('2d');
                tempCanvas.width = imgElement.naturalWidth || imgElement.width;
                tempCanvas.height = imgElement.naturalHeight || imgElement.height;
                ctx.drawImage(imgElement, 0, 0);

                var imageData = ctx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
                var data = imageData.data;
                var minX = tempCanvas.width, minY = tempCanvas.height, maxX = 0, maxY = 0;

                for (var y = 0; y < tempCanvas.height; y++) {
                    for (var x = 0; x < tempCanvas.width; x++) {
                        var alpha = data[(y * tempCanvas.width + x) * 4 + 3];
                        if (alpha > 10) {
                            if (x < minX) minX = x;
                            if (x > maxX) maxX = x;
                            if (y < minY) minY = y;
                            if (y > maxY) maxY = y;
                        }
                    }
                }

                fabricObject.set({
                    cropX: minX,
                    cropY: minY,
                    width: maxX - minX,
                    height: maxY - minY,
                    padding: 0,
                    // ← KEEP bounding box so it cannot move outside main image
                    boundingBox: flagBoundingBoxJSON,      // ← USE flagBoundingBoxJSON here
                    boundingBoxMode: "limitModify"
                });

                fabricObject.setCoords();
                canvas.renderAll();

            }, 200);
        }
        // ← END BLOCK

         if (fabricObject.custom_type == "text") {
             currentelementId = fabricObject.id;
             elementIdArr[fabricObject.custom_index] = fabricObject.id;
             global_image_category = "text";
         }

         currentelementId = elementIdArr;
         globalFrameIDForTextToAlign = elementIdArr;

         if (fabricObject.title == "Base") {

             frameId = fabricObject.id;
             if(fixed_text.length == 0){
                StrapCurrentFrame = {
                    "left": fabricObject.left,
                    "top": fabricObject.top,
                    "width": fabricObject.width,
                    "height": fabricObject.height
                }

                StrapCurrentFrameBoundingBox = {
                    "width": StrapCurrentFrame.width,
                    "height": StrapCurrentFrame.height,
                    y: 47,
                    x: -3
                };

                if (strap_position == "right_strap") {
                    StrapCurrentFrameBoundingBox = {
                        "width": StrapCurrentFrame.width,
                        "height": StrapCurrentFrame.height,
                        y: 40,
                        x: 55
                    };
                }
             }
         }

         if (global_image_category == "Strap") {
             
             //console.log("Strap being added:", fabricObject.title);
             // **Check if this strap already exists on canvas**
                var all_elements = yourDesigner.getElements();
                var strap_already_exists = false;
                
                for (var i = 0; i < all_elements.length; i++) {
                    if (all_elements[i].title === fabricObject.title && 
                        all_elements[i].id !== fabricObject.id) {
                        
                        //console.log("Found duplicate strap, removing old one:", all_elements[i].id);
                        
                        // Remove the old strap
                        yourDesigner.currentViewInstance.removeElement(all_elements[i]);
                        strap_already_exists = true;
                        break;
                    }
                }
                
                if (strap_already_exists) {
                    //console.log("Replaced old strap with new one");
                } else {
                    //console.log("First time adding this strap");
                }

             currentElementID = fabricObject.id;

             var currentelementId = fabricObject.id;
             var frameData = {
                 id: currentelementId,
                 type: "image",
                 image_category: "Strap",
                 title: fabricObject.title
             };

             if (typeof frameJson[currentelementId] == "undefined") {
                 frameJson[currentelementId] = new Array();
             }

             frameJson[currentelementId].push(frameData);
             var current_frame_image = getDetailsByAttr(frameJson[currentelementId], 'type', "image");

             //console.log("Strap added:", fabricObject.title);
             //setTimeout(function() {
                calculate_price();
             //}, 100);
             return;
         }

         if (fabricObject.category != "strap_images") {
             calculate_price();
         }
         //calculate_price();

     });

    //  $yourDesigner.on('elementRemove', function(evt, fabricObject) {
    //      if (fabricObject != null) {
    //          if (fabricObject.custom_type == "text") {
    //              var index = search_index(elementIdArr, fabricObject.id);
    //              if (index != -1) {
    //                  delete elementIdArr[index];
    //                  $('.input-text-element[data-index="' + index + '"]').val('');
    //              }
    //          }
    //          if (fabricObject.category === "strap_images") {
    //             console.log("Strap removed:", fabricObject.title);
    //         }
    //      }
    //      calculate_price();
    //  });


     $yourDesigner.on('elementRemove', function(evt, fabricObject) {
        if (fabricObject != null) {
            if (fabricObject.custom_type == "text") {
                var index = search_index(elementIdArr, fabricObject.id);
                if (index != -1) {
                    delete elementIdArr[index];
                    $('.input-text-element[data-index="' + index + '"]').val('');
                }
            }
            if (fabricObject.category === "strap_images") {
                //console.log("Strap removed:", fabricObject.title);
            }

            // ✅ FIXED: Sync flag grid when flag removed from canvas (via trash icon or any method)
            if (fabricObject.image_category === "Flags" || fabricObject.custom_type === "image") {
                
                var removedSource = fabricObject.source || '';
                var removedTitle  = fabricObject.title  || '';

                //console.log("Element removed - source:", removedSource, "title:", removedTitle);

                // Try matching by source first, then by title
                var $matchedGridItem = null;

                if (removedSource) {
                    $matchedGridItem = $('.flag-grid-item[data-source="' + removedSource + '"]');
                }

                // Fallback: match by title if source didn't find anything
                if (!$matchedGridItem || $matchedGridItem.length === 0) {
                    $matchedGridItem = $('.flag-grid-item[data-title="' + removedTitle + '"]');
                }

                if ($matchedGridItem && $matchedGridItem.length > 0) {
                    //console.log("Found grid item to deselect:", removedTitle);
                    
                    $matchedGridItem
                        .removeClass('flag-selected')
                        .css({ border: '2px solid #e0e0e0' });
                    
                    $matchedGridItem.find('.flag-badge').hide().text('');
                    $matchedGridItem.find('.flag-check').hide();

                    // Refresh ALL badges to keep numbering correct
                    var count = 0;
                    $('.flag-grid-item.flag-selected').each(function() {
                        count++;
                        $(this).find('.flag-badge').text(count).css('display', 'flex');
                        $(this).find('.flag-check').css('display', 'flex');
                        $(this).css({ border: '2px solid #c8a84b' });
                    });

                    // Update counter display
                    $('.flag-count-display').text(count + '/6');
                    
                    //console.log("Grid updated. Remaining selected:", count);
                }
            }
        }
        calculate_price();
    });


     $yourDesigner.on('elementSelect', function(evt, fabricObject) {

         if (fabricObject != null) {
             if (fabricObject.custom_type == "text") {


                 currentelementId = fabricObject.id;

                 if (fixed_text.length > 0) {
                     $('.custom-google-fonts').val(fabricObject.fontFamily);
                     $('.custom-font-size').val(fabricObject.fontSize);

                     $('.color-picker').removeClass("active-color-element");
                     $('input[value="' + fabricObject.fill + '"].color-picker').addClass("active-color-element");
                     $('.border-picker').removeClass("active-border-color-element");
                     $('input[value="' + fabricObject.shadowColor + '"].border-picker').addClass("active-border-color-element");

                     $('input[value="' + fabricObject.custom_text_allignment + '"]').prop("checked", true);
                     $('input[value="' + fabricObject.custom_text_allignment + '"]:first').trigger("click");
                 } else {

                 }

             }
         }

     });

     $yourDesigner.on('ready', function() {
        // Use setImmediate-like behavior (fastest possible)
            
            Promise.resolve().then(function() {
                $('.slick-slide h3').each(function() {
                    var text = $(this).text().trim();
                    if (text === 'Painting') $(this).text('PAINTINGS');
                    if (text === 'Strap') $(this).text('STRAPS');
                    if (text === 'Flags') $(this).text('FLAGS');
                });
            });

            if (editormode_chk()) {
                jQuery('.custom-image-upload').remove();
            }

         $(".fpd-content").append('<span id="scrollDownSpan"></span>');


         
        // ====================================================
        // ✅ FLAG GRID — PASTE STARTS HERE
        // ====================================================
        if(flags && flags.length > 0){

            $('.flag-selection-wrapper').remove();

            var flagHTML = '<div class="flag-selection-wrapper" style="margin-top: 12px; padding: 0px;">';
            
            flagHTML += '<div class="flag-toggle-btn" style="' +
                'display: flex;' +
                'align-items: center;' +
                'justify-content: space-between;' +
                'cursor: pointer;' +
                'padding: 7px 10px;' +
                'background: #f0f0f0;' +
                'border-radius: 4px;' +
                'user-select: none;' +
                'margin-bottom: 4px;' +
            '">' +
                '<span style="font-weight:bold; font-size:13px;">Image Selection ' +
                    '<span class="flag-count-display" style="font-weight:normal; color:#666;">(0/6 selected)</span>' +
                '</span>' +
                '<span class="flag-toggle-icon" style="font-size:16px; line-height:1;">▼</span>' +
            '</div>';

            flagHTML += '<div class="flag-grid-container" style="' +
                'display: none;' +
                'flex-wrap: wrap;' +
                'gap: 15px;' +
                'padding: 6px 2px;' +
                'max-height: 210px;' +
                'overflow-y: auto;' +
            '">';

            for(var fi = 0; fi < flags.length; fi++){
                var flagItem = flags[fi];
                var thumbnail = flagItem.thumbnail ? flagItem.thumbnail : flagItem.source;
                flagHTML += '<div class="flag-grid-container"' +
                    ' data-source="' + flagItem.source + '"' +
                    ' data-title="' + flagItem.title + '"' +
                    ' title="' + flagItem.title + '"' +
                    ' style="' +
                        'width: 70px;' +
                        'height: 60px;' +
                        'cursor: pointer;' +
                        'border: 2px solid #ddd;' +
                        'border-radius: 4px;' +
                        'overflow: hidden;' +
                        'background: #fafafa;' +
                        'flex-shrink: 0;' +
                        'transition: border-color 0.15s;' +
                    '">' +
                    '<img src="' + thumbnail + '"' +
                        ' style="width:100%; height:100%; object-fit:contain; pointer-events:none;"' +
                        ' title="' + flagItem.title + '"' +
                    '/>' +
                '</div>';
            }

            flagHTML += '</div></div>';

            setTimeout(function(){

            $('.flag-selection-wrapper').remove();

            var flagGridItemsHTML = '';
            for(var fi = 0; fi < flags.length; fi++){
                var flagItem = flags[fi];
                var thumbnail = flagItem.thumbnail ? flagItem.thumbnail : flagItem.source;
                var cat = flagItem.image_category || 'Other';
                flagGridItemsHTML += '<div class="flag-grid-item"' +
                    ' data-source="' + flagItem.source + '"' +
                    ' data-title="' + flagItem.title + '"' +
                    ' data-cat="' + cat + '"' +
                    ' title="' + flagItem.title + '"' +
                    ' style="' +
                        'width: 80px;' +
                        'height: 80px;' +
                        'cursor: pointer;' +
                        'border: 2px solid #e0e0e0;' +
                        'border-radius: 10px;' +
                        'overflow: visible;' +
                        'background: #fff;' +
                        'flex-shrink: 0;' +
                        'position: relative;' +
                        'box-sizing: border-box;' +
                        'display: flex;' +
                        'align-items: center;' +
                        'justify-content: center;' +
                    '">' +
                    '<img src="' + thumbnail + '"' +
                        ' style="width:100%; height:75%; object-fit:cover; pointer-events:none;" />' +
                    '<span class="flag-badge" style="' +
                        'display: none;' +
                        'position: absolute;' +
                        'top: -8px;' +
                        'left: -8px;' +
                        'width: 22px;' +
                        'height: 22px;' +
                        'background: #c8a84b;' +
                        'color: #fff;' +
                        'border-radius: 50%;' +
                        'font-size: 11px;' +
                        'font-weight: bold;' +
                        'align-items: center;' +
                        'justify-content: center;' +
                        'z-index: 2;' +
                    '"></span>' +
                    '<span class="flag-check" style="' +
                        'display: none;' +
                        'position: absolute;' +
                        'top: -8px;' +
                        'right: -8px;' +
                        'width: 20px;' +
                        'height: 20px;' +
                        'background: #c8a84b;' +
                        'color: #fff;' +
                        'border-radius: 50%;' +
                        'font-size: 13px;' +
                        'align-items: center;' +
                        'justify-content: center;' +
                        'z-index: 2;' +
                    '">✓</span>' +
                '</div>';
            }

            var flagHTML = '<div class="flag-selection-wrapper" style="margin-top: 16px; padding: 0px;">' +

                // Header
                '<div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:8px;">' +
                    '<div style="font-weight:700; font-size:13px; color:#222;">IMAGE SELECTION</div>' +
                    '<div style="font-size:13px; color:#888;">Selected: <span class="flag-count-display" style="font-weight:700; color:#c8a84b;">0/6</span></div>' +
                '</div>' +

                // Sub label
                '<div style="font-size:13px; color:#888; margin-bottom:10px;">Select up to 6 images</div>' +

                // Grid
                '<div class="flag-grid-container" style="' +
                    'display: flex;' +
                    'flex-wrap: wrap;' +
                    'gap: 15px;' +
                    'max-height: 280px;' +
                    'overflow-y: auto;' +
                    'padding: 8px 8px;' +
                '">' + flagGridItemsHTML + '</div>' +

                // Footer note
                '<div style="' +
                    'margin-top: 10px;' +
                    'border: 1px dashed #e57373;' +
                    'border-radius: 6px;' +
                    'padding: 6px 10px;' +
                    'font-size: 11px;' +
                    'color: #e57373;' +
                    'text-align: center;' +
                '">Pre-uploaded images only · No customer uploads · Free drag positioning</div>' +

            '</div>';

            // Insert after Font Selection label
            var inserted = false;
            $('label.heading').each(function(){
                if($(this).text().trim().indexOf('Font Selection') !== -1){
                    $(this).after(flagHTML);
                    inserted = true;
                    return false;
                }
            });
            if(!inserted && $('.custom-google-fonts').length > 0){
                $('.custom-google-fonts').after(flagHTML);
                inserted = true;
            }
            if(!inserted){
                $('.mainPopup').find('.input-container').after(flagHTML);
            }

            // ── Badge numbering helper ───────────────────────────────
            function refreshBadges(){
                var count = 0;
                $('.flag-grid-item.flag-selected').each(function(){
                    count++;
                    $(this).find('.flag-badge').text(count).css('display', 'flex');
                    $(this).find('.flag-check').css('display', 'flex');
                });
                $('.flag-count-display').text(count + '/6');
            }

            // ── Flag click: select / deselect ────────────────────────
            $(document).off('click', '.flag-grid-item').on('click', '.flag-grid-item', function(){
                var $this = $(this);
                var source = $this.data('source');
                var title  = $this.data('title');

                if($this.hasClass('flag-selected')){
                    // Remove from canvas
                    var allElements = yourDesigner.getElements();
                    for(var ei = 0; ei < allElements.length; ei++){
                        if(allElements[ei].source === source){
                            yourDesigner.currentViewInstance.removeElement(allElements[ei]);
                            break;
                        }
                    }
                    $this.removeClass('flag-selected')
                        .css({ border: '2px solid #e0e0e0' });
                    $this.find('.flag-badge').hide();
                    $this.find('.flag-check').hide();
                    refreshBadges();
                    return;
                }

                // Max 6 check
                if($('.flag-grid-item.flag-selected').length >= 6){
                    alert("You can't select more than 6 images.");
                    return;
                }

                // Add to canvas
                global_image_category = "Flags";
                yourDesigner.currentViewInstance.addElement("image", source, title, {
                    isCustom: true,
                    custom_type: "image",
                    image_category: "Flags",
                    removable: true,
                    draggable: true,
                    rotatable: true,
                    resizable: true,
                    copyable: false,
                    topped: true,
                    autoCenter: true,
                    scaleX: 0.16,
                    scaleY: 0.16,
                    padding: 0,
                    boundingBoxMode: "limitModify",
                    boundingBox: flagBoundingBoxJSON  // ← USE flagBoundingBoxJSON here
                });

                $this.addClass('flag-selected')
                    .css({ border: '2px solid #c8a84b' });
                refreshBadges();
            });

        }, 500);

        } else {
            $('.flag-selection-wrapper').remove();
        }
        // ====================================================
        // ✅ FLAG GRID — PASTE ENDS HERE
        // ====================================================


         $yourDesigner.on("productCreate", function() {

             if (check_previous_saved_setting != null) {

                 check_previous_saved_setting = JSON.stringify(check_previous_saved_setting).replace(/"false"/g, false);
                 check_previous_saved_setting = check_previous_saved_setting.replace(/"true"/g, true);
                 check_previous_saved_setting = JSON.parse(check_previous_saved_setting);;
                 var custom_element = check_previous_saved_setting[0].elements;

                 for (var j = 1; j < custom_element.length; j++) {

                     if (custom_element[j].parameters.custom_type == "text") {

                         custom_element[j].source = String(custom_element[j].parameters.original_text);
                         custom_element[j].title = String(custom_element[j].parameters.original_text);
                         custom_element[j].parameters.text = String(custom_element[j].parameters.text);
                         custom_element[j].parameters.original_text = custom_element[j].parameters.original_text;

                         if (j > 1) {
                             insert_text_html_element($('.add-more-text-element:first'));
                         }

                         $('.input-text-element').eq([j - 1]).val(custom_element[j].parameters.original_text); 

                         custom_element[j].parameters.custom_index = j - 1;
                         elementIdArr[custom_element[j].parameters.custom_index] = 0;

                         if(fixed_text.length == 0){

                                 var element = yourDesigner.currentViewInstance.addElement("text", custom_element[j].parameters.text, custom_element[j].parameters.text, {
                                        custom_type: "text",
                                      original_text: custom_element[j].parameters.original_text,
                                      custom_text_allignment: custom_element[j].parameters.custom_text_allignment,
                                        colors:true,
                                        color: "#fff",
                                   fontSize: custom_element[j].parameters.fontSize,
                                    strokeBlur: custom_element[j].parameters.strokeBlur,
                                        shadowOffsetX: custom_element[j].parameters.shadowOffsetX,
                                        shadowOffsetY: custom_element[j].parameters.shadowOffsetY,
                                   shadowColor:  custom_element[j].parameters.shadowColor,
                                        fill: custom_element[j].parameters.fill,  
                                   fontFamily: custom_element[j].parameters.fontFamily,  
                                        price: 20,
                                        "removable": true,
                                      "draggable": true,
                                      "rotatable": true,
                                      "resizable": true,
                                      "editable": false,
                                      "custom_index": custom_element[j].parameters.custom_index,
                                        "boundingBoxMode": "limitModify",
                                        boundingBox: boundingBoxJSON,
                                     	 left: custom_element[j].parameters.left,
                                   		top: custom_element[j].parameters.top,
                                     width: custom_element[j].parameters.width,
                                     height: custom_element[j].parameters.height,
                                     rotatable: custom_element[j].parameters.rotatable,
                                     angle: custom_element[j].parameters.angle,
                                     scaleMode: custom_element[j].parameters.scaleMode,
                                     resizable: custom_element[j].parameters.resizable
                                   
                                 });
                                }
                                else
                                {


                                    $(".custom-google-fonts").css("display",'none');
                                    $(".swatches").css("display",'none');
                                    $(".swatches").css("display",'none');
                                    $(".swatches_border").css("display",'none');
                                    $(".select2-container--default .select2-selection--single").css("display",'none');
                                    $(".select2.select2-container.select2-container--default").css("display",'none');

                                    $(".input-text-element").attr("style" ,"text-transform:uppercase")
                                    $(".fpd-tooltip.tooltipstered:nth-child(3)").css("display", "none");
                                    $(".fpd-tooltip.tooltipstered:nth-child(2)").css("display", "none");
                                    $(".fpd-tooltip.tooltipstered:nth-child(1)").addClass('fpd-active');

                                    $(".input-text-element").addClass("Calibri-Font");

                                    
                                  var element_new = yourDesigner.currentViewInstance.addElement("text", custom_element[j].parameters.text, custom_element[j].parameters.text, {
                                      custom_type: "text",
                                      original_text: custom_element[j].parameters.original_text,
                                      custom_text_allignment: custom_element[j].parameters.custom_text_allignment,
                                      colors:true,
                                      color: "#fff",
                                      fontSize: 40,
                                      strokeBlur: custom_element[j].parameters.strokeBlur,
                                      shadowOffsetX: custom_element[j].parameters.shadowOffsetX,
                                      shadowOffsetY: custom_element[j].parameters.shadowOffsetY,
                                      shadowColor:  custom_element[j].parameters.shadowColor,
                                      fill: custom_element[j].parameters.fill,  
                                      "removable": false,
                                      "draggable": false,
                                      "rotatable": false,
                                      "resizable": false,
                                      "editable": false,
                                      "custom_index": custom_element[j].parameters.custom_index,
                                      "boundingBoxMode": "limitModify",
                                      left: 162,
                                      top: custom_element[j].parameters.top,
                                      textTransform:"uppercase",
                                      fontStyle:"italic",
                                      fontWeight:"bold",
                                      textAlign:'center'
                                   
                                 });
                                   

                                }

                     } else if (custom_element[j].parameters.custom_type == "image") {
                         var element = yourDesigner.currentViewInstance.addElement("image", custom_element[j].source, custom_element[j].title, {
                             "zChangeable": true,
                             color: "#fff",
                             custom_type: "image",
                             "removable": true,
                             "draggable": true,
                             "rotatable": true,
                             "resizable": true,
                             "copyable": false,

                             "boundingBoxMode": "limitModify",
                             boundingBox: boundingBoxJSON,
                             scaleX: custom_element[j].parameters.scaleX,
                             scaleY: custom_element[j].parameters.scaleY,
                             left: custom_element[j].parameters.left,
                             top: custom_element[j].parameters.top,
                             width: custom_element[j].parameters.width,
                             height: custom_element[j].parameters.height,
                             rotatable: custom_element[j].parameters.rotatable,
                             angle: custom_element[j].parameters.angle,
                             scaleMode: custom_element[j].parameters.scaleMode,
                             resizable: custom_element[j].parameters.resizable,
                             textAlign:'center'

                         });

                     }

                 }
             } else {

                 if(fixed_text.length > 0)
                {

                       $(".custom-google-fonts").css("display",'none');
                       $(".swatches").css("display",'none');
                       $(".swatches").css("display",'none');
                       $(".swatches_border").css("display",'none');
                       $(".select2-container--default .select2-selection--single").css("display",'none');
                       $(".select2.select2-container.select2-container--default").css("display",'none');
                  
                        $(".input-text-element").attr("style" ,"text-transform:uppercase")
                         $(".fpd-tooltip.tooltipstered:nth-child(3)").css("display", "none");
                         $(".fpd-tooltip.tooltipstered:nth-child(2)").css("display", "none");
                         $(".fpd-tooltip.tooltipstered:nth-child(1)").addClass('fpd-active');

                         $(".input-text-element").addClass("Calibri-Font");

                         // ✅ Get font name safely
                         var fixedFontName = '';
                         if(fixed_text_font_family && fixed_text_font_family['font_name']) {
                            fixedFontName = fixed_text_font_family['font_name'];
                         } else if(fixed_text_font_family && fixed_text_font_family['fontFamily']) {
                            fixedFontName = fixed_text_font_family['fontFamily'];
                         }
                            
                         //console.log("Fixed font name:", fixedFontName);
                         //console.log("Fixed font full object:", fixed_text_font_family);

                        //   var element = yourDesigner.currentViewInstance.addElement("text", "", "", {
                        //       autoCenter: true,
                        //       custom_type: "text",
                        //       original_text: "",
                        //       custom_text_allignment: 'Horizontal',
                        //       colors: true,
                        //       color: fixed_text_color,
                        //       price: 20,
                        //       "removable": false,
                        //       "draggable": false,
                        //       "rotatable": false,
                        //       "resizable": false,
                        //       "editable": true,
                        //       "topped": true,
                        //       "custom_index": 0,
                        //       "boundingBoxMode": textBoundingBoxMode,
                        //       boundingBox: textBoundingBox,
                        //       textTransform:"uppercase",
                        //   });
                        var lockFixedText = (fixed_text.length > 0 && (!flags || flags.length === 0));
                        var autoCenterValue = true;
                        if (lockFixedText) {
                            autoCenterValue = false;
                        }
                     // ✅ Add element WITH fontFamily directly
                    var element = yourDesigner.currentViewInstance.addElement("text", "", "", {
                        autoCenter: autoCenterValue,
                        custom_type: "text",
                        original_text: "",
                        custom_text_allignment: 'Horizontal',
                        colors: true,
                        color: fixed_text_color,
                        price: 20,
                        "removable": false,
                        "draggable": !lockFixedText,
                        "rotatable": !lockFixedText,
                        "resizable": !lockFixedText,
                        "editable": false,
                        "topped": true,
                        "custom_index": 0,
                        "boundingBoxMode": textBoundingBoxMode,
                        boundingBox: textBoundingBox,
                        textTransform: "uppercase",
                        strokeBlur: 3,
                        shadowOffsetX: -3,
                        shadowOffsetY: 3,
                        top: 225,
                        left: 160,
                        fontSize: 47,
                        shadowColor: fixed_text_border_color,
                        fontFamily: fixedFontName,  // ✅ Set font HERE directly
                        textAlign: 'center'
                    });

                    //  var currentelement = yourDesigner.currentViewInstance.getElementByID(globalFrameIDForTextToAlign);
                    //  var element = yourDesigner.currentViewInstance.changeColor(currentelement, fixed_text_color);
                    //  var element1 = yourDesigner.currentViewInstance.setElementParameters({
                    //   strokeBlur: 3,
                    //   shadowOffsetX: -3,
                    //   shadowOffsetY: 3,
                    //   top:225,
                    //   left:160,
                    //   fontSize: 47,
                    //   shadowColor: fixed_text_border_color,
                    //   fontFamily: fixed_text_font_family['font_name'],
                    //   textAlign:'center'

                    // }, currentelement);

                     // ✅ Also apply via setElementParameters after short delay
                    // using the CORRECT element ID from globalFrameIDForTextToAlign
                    setTimeout(function() {
                        // globalFrameIDForTextToAlign is updated in elementAdd event
                        var lastAddedId = elementIdArr[0]; // text was added with custom_index: 0
                        //console.log("Applying font to element ID:", lastAddedId);
                        
                        var currentelement = yourDesigner.currentViewInstance.getElementByID(lastAddedId);
                        //console.log("Element found:", currentelement);
                        
                        if(currentelement) {
                            yourDesigner.currentViewInstance.changeColor(currentelement, fixed_text_color);
                            yourDesigner.currentViewInstance.setElementParameters({
                                fontFamily: fixedFontName,
                                fontSize: 47,
                                strokeBlur: 3,
                                shadowOffsetX: -3,
                                shadowOffsetY: 3,
                                shadowColor: fixed_text_border_color,
                                textAlign: 'center'
                            }, currentelement);
                            //console.log("Font applied:", currentelement.fontFamily);
                        } else {
                            console.error("Element not found! elementIdArr:", elementIdArr);
                        }
                    }, 500);

                }
                 if(fixed_text_ipod == "yes")  
                 {
                 
                   $('.swatches').first().hide();
                   
                    $(".fpd-tooltip.tooltipstered:nth-child(3)").css("display", "none");
                     $(".fpd-tooltip.tooltipstered:nth-child(2)").css("display", "none");
                     $(".fpd-tooltip.tooltipstered:nth-child(1)").addClass('fpd-active');
                      var font_family = $('.custom-google-fonts').val() != 0 ? $('.custom-google-fonts').val() : 'Amiri Regular - Font';
                      //console.log(font_family+ " font_family");
                      var element = yourDesigner.currentViewInstance.addElement("text", "", "", {
                         autoCenter: true,
                         custom_type: "text",
                         original_text: "",
                         custom_text_allignment: 'Horizontal',
                         colors: true,
                         price: 20,
                         "removable": false,
                         "draggable": false,
                         "rotatable": false,
                         "resizable": false,
                         "editable": true,
                         "topped": true,
                         "custom_index": 0,
                         "boundingBoxMode": textBoundingBoxMode,
                         boundingBox: textBoundingBox,
                         textTransform: "uppercase",
                         strokeBlur: 3,
                         shadowOffsetX: 3,
                         shadowOffsetY: 0,
                         fontSize: 80,
                          fontColor: "#ffffff",
                          fill:"#ffffff",
                        fontFamily : font_family,
                     });
                    var elementsecond = yourDesigner.currentViewInstance.addElement("text", "", "", {
                          title : "second",
                         custom_type: "text",
                         original_text:"sss",
                         custom_text_allignment: 'Horizontal',
                         colors: true,
                          strokeBlur: 3,
                         shadowOffsetX: 3,
                         shadowOffsetY: 0,
                         fontSize: 80,
                         "removable": false,
                         "draggable": false,
                         "rotatable": false,
                         "resizable": false,
                         "editable": false,
                         "boundingBoxMode": "limitModify",
                         textTransform: "uppercase",
                          fontColor: "#ffffff",
                          fill:"#ffffff",
                        fontFamily : font_family,
                      
                     });
                 }
             }

         });

         $("#fpd-custom-design-form").validate({
             onkeyup: function(element) {
                 $(element).valid()
             },
             rules: {

             }
         });

         $(".character-allowed-count").text(max_character_allowed);
         $(".max-image-upload-size").text(max_image_size);

         $('.input-text-element').prop("maxlength", max_character_allowed);

         $.validator.addClassRules("input-text-element", {
             maxlength: max_character_allowed
         });

         var len = fonts_order.length;
            for (i = 0; i < len; i++) {
                fontChangeClassName = fonts_order[i].name.replace(/\s+/g, '');
                
                // Check if the font name contains "Italic" (case-insensitive)
                var isItalic = fonts_order[i].name.toLowerCase().indexOf('italic') !== -1;
                var default_selected = isItalic ? 'selected="selected"' : "";
                
                $('.custom-google-fonts').append('<option value="' + fonts_order[i].name + '"' + default_selected + ' class="' + fontChangeClassName + '">' + fonts_order[i].name + '</option>');
            }

         function formatFontElement(state) {

             fontChangeClassName = state.text.replace(/\s+/g, '');
             var $state = $(
                 '<span' + ' style="font-family:' + fontChangeClassName + '; font-size:16px">' + state.text + '</span>'
             );
             return $state;
         };

         $('.custom-google-fonts').select2({
             templateResult: formatFontElement,
             templateSelection: formatFontElement
         });

        //  if ($('.custom-google-fonts').parent('.swatches').length === 0) {
        //     //$('.custom-google-fonts').wrap('<div class="swatches"></div>');
        //     $('.custom-google-fonts').before('<label class="heading">Font Selection:</label>');
        //  }

        if ($('.custom-google-fonts').parent('.swatches').length === 0) {
            $('.custom-google-fonts').before('<label class="heading">Font Selection:</label>');
        }


        // Populate flag grid
        var flagContainer = $('.flag-grid-container');
        flagContainer.empty();

        if(flags && flags.length > 0){
            for(var fi = 0; fi < flags.length; fi++){
                var flagItem = flags[fi];
                var thumbnail = flagItem.thumbnail ? flagItem.thumbnail : flagItem.source;
                flagContainer.append(
                    '<div class="flag-grid-item" ' +
                        'data-source="' + flagItem.source + '" ' +
                        'data-title="' + flagItem.title + '" ' +
                        'style="' +
                            'width: 44px;' +
                            'height: 44px;' +
                            'cursor: pointer;' +
                            'border: 2px solid transparent;' +
                            'border-radius: 4px;' +
                            'overflow: hidden;' +
                            'position: relative;' +
                            'background: #f5f5f5;' +
                        '">' +
                        '<img src="' + thumbnail + '" ' +
                            'title="' + flagItem.title + '" ' +
                            'style="width:100%; height:100%; object-fit:contain;" />' +
                    '</div>'
                );
            }
        }

        // Flag click handler
        $(document).on('click', '.flag-grid-item', function(){
            var $this = $(this);
            var source = $this.data('source');
            var title = $this.data('title');

            // Check if already selected (toggle off)
            if($this.hasClass('flag-selected')){
                // Find and remove this flag from canvas
                var allElements = yourDesigner.getElements();
                for(var i = 0; i < allElements.length; i++){
                    if(allElements[i].source === source){
                        yourDesigner.currentViewInstance.removeElement(allElements[i]);
                        break;
                    }
                }
                $this.removeClass('flag-selected').css('border-color', 'transparent');
                updateFlagCount();
                return;
            }

            // Check max 6 flags
            var currentFlagCount = $('.flag-grid-item.flag-selected').length;
            if(currentFlagCount >= 6){
                alert("You can't select more than 6 flags.");
                return;
            }

            // Add flag to canvas
            global_image_category = "Flags";

            var flagParams = {
                isCustom: true,
                custom_type: "image",
                removable: true,
                draggable: true,
                rotatable: true,
                resizable: true,
                copyable: false,
                topped: true,
                autoCenter: true,
                scaleX: 0.16,
                scaleY: 0.16,
                boundingBoxMode: "limitModify",
                boundingBox: boundingBoxJSON
            };

            yourDesigner.currentViewInstance.addElement("image", source, title, flagParams);

            $this.addClass('flag-selected').css('border-color', '#2185d0');
            updateFlagCount();
        });

        function updateFlagCount(){
            var count = $('.flag-grid-item.flag-selected').length;
            $('.flag-count-display').text('(' + count + '/6 selected)');
        }
         

         $('.text-color-designer').html('');
         var len1 = text_color.length;
         for (i = 0; i < len1; i++) {
             var activeClass = (text_color[i].color_code === '#FFFFFF') ? ' active-color-element' : '';

             $('.text-color-designer').append(
                 '<input type="radio" name="color-radio" value="' + text_color[i].color_code + '" data-module="color" class="red color-picker' + activeClass + '" style="background-color: ' + text_color[i].color_code + ' !important;">'
             );
         }

         //$('.text-color-designer').append('<button type="button" id="clear-color-selection"><img class="clear" src="https://cdn.shopify.com/s/files/1/0687/8537/3458/files/5082-512-_1_-removebg-preview.png?v=1728477036" alt="Girl in a jacket"></button>');

         /*$('#clear-color-selection').on('click', function() {

             $('input[name="color-radio"]').prop('checked', false);
             $('.color-picker').removeClass('active-color-element');
             var element_value = '#ffffff';
             var currentelement = yourDesigner.currentViewInstance.getElementByID(globalFrameIDForTextToAlign);
             var element = yourDesigner.currentViewInstance.changeColor(currentelement, element_value);
              if(fixed_text_ipod == 'yes')
                 {
                    var currentelement1 = yourDesigner.currentViewInstance.getElementByID(elementIdArr['undefined']);
                    var element1 = yourDesigner.currentViewInstance.changeColor(currentelement1, element_value);
                 }
           
         });*/

         $('.text-border-color').html('');
         var len4 = text_border_color.length;

         for (i = 0; i < len4; i++) {

             $('.text-border-color').append('  <input type="radio" name="border-radio" value="' + text_border_color[i].color_code + '" data-module="color" class="red border-picker" style="background-color: ' + text_border_color[i].color_code + ' !important;">');
         }

         $('.text-border-color').append('<button type="button" id="clear-border-selection"><img class="clear" src="https://cdn.shopify.com/s/files/1/0687/8537/3458/files/5082-512-_1_-removebg-preview.png?v=1728477036" alt="Girl in a jacket"></button>');

         $('#clear-border-selection').on('click', function() {
             $('.border-picker').removeClass("active-border-color-element");
             var currentelement = yourDesigner.currentViewInstance.getElementByID(globalFrameIDForTextToAlign);

             var element = yourDesigner.currentViewInstance.setElementParameters({
                 strokeBlur: 3,
                 shadowOffsetX: 2,
                 shadowOffsetY: 0,
                 shadowColor: ''
             }, currentelement);

               if(fixed_text_ipod == 'yes')
                 {
                    var currentelement1 = yourDesigner.currentViewInstance.getElementByID(elementIdArr['undefined']);

                     var element = yourDesigner.currentViewInstance.setElementParameters({
                       strokeBlur: 3,
                       shadowOffsetX: 2,
                       shadowOffsetY: 0,
                       shadowColor: ''
                     }, currentelement1);
                 }

         });

         $('.custom-font-size').html('<option value="0">select font size</option>');
         var len2 = text_size.length;
         for (i = 0; i < len2; i++) {
             var default_selected = text_size[i].size == 45 ? 'selected="selected"' : "";
             $('.custom-font-size').append('<option value="' + text_size[i].size + '" ' + default_selected + '>' + text_size[i].size + '</option>');
         }

         $('.custom-font-css').html('<option value="0">select custom font css</option>');
         var len5 = custom_font_css.length;
         for (i = 0; i < len5; i++) {
             $('.custom-font-css').append('<option value="' + custom_font_css[i].id + '">' + custom_font_css[i].name + '</option>');
         }

         $('.text-alignment-radio').html('');

         $('.text-alignment-radio').append('<input type="radio" name="border-radio1" value="Horizontal" data-module="color" class="new-radio-1 text-alignent-radio" checked="checked">  <label class="textlb" for="Vertical"> <i class="fa fa-arrows-h" aria-hidden="true"></i> Horizontal</label>  &nbsp; <input type="radio" name="border-radio1" value="Vertical" data-module="color" class="new-radio text-alignent-radio">  <label class="textlb" for="Vertical"> <i class="fa fa-arrows-v" aria-hidden="true"></i> Vertical</label>');

         // Change "Direction:" to "Orientation:"
         $('.text-alignment-radio').siblings('label.heading').text('Font Direction:');

         // change text border color to font highlight color
         const label = document.querySelector('.swatches_border lebal');
            if (label) {
                label.textContent = "Font Highlight Color:";
            }

         // change custom image upload message
         $('.custom-image-upload .image-upload-item > span')
          .html('Please ensure the image size does not exceed 1024 KB.');
         
         $('input[value="Horizontal"]:first').trigger("click");

         $('.fpd-module').on('change', '.border-picker', function(evt) {

             $('.border-picker').removeClass("active-border-color-element");
             $(this).addClass("active-border-color-element");

             var element_value = $(this).val();

             var currentelement = yourDesigner.currentViewInstance.getElementByID(globalFrameIDForTextToAlign);

             var element = yourDesigner.currentViewInstance.setElementParameters({
                 strokeBlur: 3,
                 shadowOffsetX: 2,
                 shadowOffsetY: 0,
                 shadowColor: element_value
             }, currentelement);


              if(fixed_text_ipod == 'yes')
                 {
                    var currentelement1 = yourDesigner.currentViewInstance.getElementByID(elementIdArr['undefined']);

                     var element = yourDesigner.currentViewInstance.setElementParameters({
                         strokeBlur: 3,
                         shadowOffsetX: 2,
                         shadowOffsetY: 0,
                         shadowColor: element_value
                     }, currentelement1);
                 }

         });

         $('.fpd-module').on('change', '.custom-google-fonts,.custom-font-size', function(evt) {
             var index = 0;
             var element_name = $(this).attr("data-module");
             var element_value = $(this).val();
             var obj = new Object;
             obj[element_name] = element_value;

             if (element_name == "fontSize") {
                 element_value = parseInt(element_value, 10);
                 obj[element_name] = element_value;
             }

             var currentelement = yourDesigner.currentViewInstance.getElementByID(globalFrameIDForTextToAlign);

             if (element_name == "fontSize") {

                 var extra_left = boundingBoxJSON.width - currentelement.aCoords.tr.x;
                 var extra_font = element_value - currentelement.fontSize; 
                 if (extra_left < extra_font) {
                     obj['autoCenter'] = true;
                 }
             }

             var element = yourDesigner.currentViewInstance.setElementParameters(obj, currentelement);
                 if(fixed_text_ipod == 'yes')
                 {
                    var currentelement1 = yourDesigner.currentViewInstance.getElementByID(elementIdArr['undefined']);
                     var element1 = yourDesigner.currentViewInstance.setElementParameters(obj, currentelement1);
                 }
         });

         $('.fpd-module').on('change', '.color-picker', function(evt) {

             $('.color-picker').removeClass("active-color-element");
             $(this).addClass("active-color-element");

             var element_name = $(this).attr("data-module");
             var element_value = $(this).val();

             var obj = new Object;
             obj[element_name] = element_value;

             var currentelement = yourDesigner.currentViewInstance.getElementByID(globalFrameIDForTextToAlign);
             var element = yourDesigner.currentViewInstance.changeColor(currentelement, element_value);

               if(fixed_text_ipod == 'yes')
                 {
                    var currentelement1 = yourDesigner.currentViewInstance.getElementByID(elementIdArr['undefined']);
                      var element1 = yourDesigner.currentViewInstance.changeColor(currentelement1, element_value);  
                 }


         });

         $('.input-container').on('keyup', '.input-text-element', function (evt) {
                                //evt.stopPropagation();
                                var text = $(this).val();
                                var index = $(this).attr("data-index") ;     
        						          //var element_value = '#ffffff';
                               // var element = yourDesigner.currentViewInstance.changeColor(currentelement, element_value);
                              if(text.length > max_character_allowed){
                                $(this).val(text.substring(0,max_character_allowed));	
                                return;
                              }
                              	
                              //   var font_size = $('.custom-font-size').val() != 0 ?  parseInt($('.custom-font-size').val()) : 45;
                              // var font_family = $('.custom-google-fonts').val() != 0 ?  $('.custom-google-fonts').val() : 'Amiri Regular - Font';
                                
                               //prj code

                                if(fixed_text.length==0){

                                    var font_family = $('.custom-google-fonts').val() != 0 ? $('.custom-google-fonts').val() : 'Amiri Regular - Font';
                                    var font_size = $('.custom-font-size').val() != 0 ? parseInt($('.custom-font-size').val()) : 45;


                                  } else if(fixed_text_ipod =='yes') {
                                        var font_family = $('.custom-google-fonts').val() != 0 ? $('.custom-google-fonts').val() : 'Amiri Regular - Font';
                                       text.toUpperCase();
                      
                                   }else
                                  {
                                     var font_family = fixed_text_font_family['font_name'];
                                     text.toUpperCase();
                                   
                                  }

                              //end 


                                if (typeof elementIdArr[index] == "undefined") {

                                   textBoundingBoxMode = "limitmodify";
                                   textBoundingBox = boundingBoxJSON;
                                  text_alignment = "Horizontal";
                                  if(text_position == "strap" && strap_position == "right_strap"){
                                      textBoundingBoxMode = "clipping";
                                      textBoundingBox = {width: 50, height:350, x:160, y:90};
                                    text_alignment = "Vertical";

                                    	$('input[value="Vertical"]:first').prop("checked", true);
                                         
                                    
                                  } else if(text_position == "strap"){
                                      textBoundingBoxMode = "clipping";
                                    //StrapCurrentFrameBoundingBox = {"width" : StrapCurrentFrame.width, "height": StrapCurrentFrame.height, y: 47, x: -3};
                                      textBoundingBox = {width: 50, height:240, x: 106, y: 150};
                                      text_alignment = "Vertical";

                                    $('input[value="Vertical"]:first').prop("checked", true);
                                  }
                                  
                                  elementIdArr[index] = 0;

                                  
                                   if(fixed_text.length == 0 ){
                                        var element = yourDesigner.currentViewInstance.addElement("text", text, text, {
                                          autoCenter: true,
                                          custom_type: "text",
                                          original_text: text,
                                          custom_text_allignment: text_alignment,
                                          colors: true,
                                          color: "#fff",
                                          price: 20,
                                          "removable": true,
                                          "draggable": true,
                                          "rotatable": true,
                                          "resizable": true,
                                          "editable": false,
                                          "topped": true,
                                          "custom_index": index,
                                          "boundingBoxMode": textBoundingBoxMode,
                                          boundingBox: textBoundingBox,
                                          fontSize: font_size,
                                          fontFamily: font_family,
                                          textAlign: 'center',
                                        });
                                     var element_value = '#ffffff';
                                     var currentelement = yourDesigner.currentViewInstance.getElementByID(elementIdArr[index]);  
                                      var element = yourDesigner.currentViewInstance.changeColor(currentelement, element_value);
                                      
                                      }
                                      else
                                      {
                                        var element = yourDesigner.currentViewInstance.addElement("text",  text,  text, {
                                          autoCenter: true,
                                          custom_type: "text",
                                          original_text:  text,
                                          custom_text_allignment: text_alignment,
                                          colors: true,
                                          color: fixed_text_color,
                                          price: 20,
                                          "removable": false,
                                          "draggable": false,
                                          "rotatable": false,
                                          "resizable": false,
                                          "editable": false,
                                          "topped": true,
                                          "custom_index": index,
                                          "boundingBoxMode": textBoundingBoxMode,
                                          boundingBox: textBoundingBox,
                                          fontSize: 46,
                                          fontFamily: fixed_text_font_family['font_name'],
                                          textAlign: 'center',
                                          
                                        });
                                        
                                      }


                                    //     console.log(element);
                                    //       console.log(yourDesigner.getElements());
                                    flag = 1;
                                } else {

                                    /*var currentelement = yourDesigner.currentViewInstance.getElementByID(elementIdArr[index]);  
                                    currentelement.original_text = text;
                                     obj = render_allignment(currentelement.custom_text_allignment, currentelement);
                                  	obj.original_text = text;
                                    var element = yourDesigner.currentViewInstance.setElementParameters(obj, currentelement);
                                    //var element_value = '#ffffff';
                                   // var element = yourDesigner.currentViewInstance.changeColor(currentelement, element_value);
                                    //jQuery('#product-actions').appendTo(".fpd-mainbar");    
                                    // jQuery('#save-container').appendTo(".fpd-mainbar");
                                    // jQuery('#save-container').show();
                                    //yourDesigner.currentViewInstance.getElementByID("");*/

                                  if(fixed_text_ipod == 'yes')
                                   {
                                      var element_value1 = '#ffffff';
                                      var currentelement = yourDesigner.currentViewInstance.getElementByID(elementIdArr[index]);
                                      currentelement.original_text = text;
                                      currentelement.top = "360";
                                      currentelement.left = "381";
                                     if(text.length == 3) {
                                       currentelement.fontSize = "60"; 
                                     } else {
                                      currentelement.fontSize = "70"; 
                                     }
                                      currentelement.set({
                                        angle: 15,
                                      });
                                       obj = render_allignment(currentelement.custom_text_allignment, currentelement);
                                      var element = yourDesigner.currentViewInstance.setElementParameters(obj, currentelement);
                                    //  var element_color = yourDesigner.currentViewInstance.changeColor(currentelement, element_value1);
                                     
                                      var currentelement1 = yourDesigner.currentViewInstance.getElementByID(elementIdArr['undefined']);
                                      currentelement1.original_text = text;
                                       currentelement1.top = "360";
                                      currentelement1.left = "115";
                                      currentelement1.text = text.toUpperCase();
                                      currentelement1.textTransform = "uppercase";
                                      if(text.length == 3) {
                                        currentelement1.fontSize = "60"; 
                                      } else {
                                      currentelement1.fontSize = "70"; 
                                      }
                                       currentelement1.set({
                                        angle: -15
                                      });
                                      obj1 = render_allignment(currentelement1.custom_text_allignment, currentelement1);
                                      var element1 = yourDesigner.currentViewInstance.setElementParameters(obj1, currentelement1);
                                      //   var element_color2 = yourDesigner.currentViewInstance.changeColor(currentelement1, element_value1);
                                   }
                                 else {
                                    // var currentelement = yourDesigner.currentViewInstance.getElementByID(elementIdArr[index]);
                                    // currentelement.original_text = text;
                                    // obj = render_allignment(currentelement.custom_text_allignment, currentelement);
                                    // obj.original_text = text;
                                    // var element = yourDesigner.currentViewInstance.setElementParameters(obj, currentelement);
                                    //  var element = yourDesigner.currentViewInstance.changeColor(currentelement, element_value);
                                     var currentelement = yourDesigner.currentViewInstance.getElementByID(elementIdArr[index]);  
                                    currentelement.original_text = text;
                                     obj = render_allignment(currentelement.custom_text_allignment, currentelement);
                                  	obj.original_text = text;
                                    var element = yourDesigner.currentViewInstance.setElementParameters(obj, currentelement);
                                    
                                  
                                   
                                 }
                                }
                              if(text.length > 0 ) {
                              	 calculate_price("add");
                              } else{
                                 calculate_price("minus");
                              }
                            })

         $('#store-product-db').click(function() {

         });
     });

     $('#print-button').click(function() {
         yourDesigner.print();
         return false;
     });

     $('#image-button').click(function() {
         var image = yourDesigner.createImage();
         return false;
     });

     $yourDesigner.on('priceChange', function(evt, price, currentPrice) {
         $('#thsirt-price').text(currentPrice);
     });

     $('#save-image-php').click(function() {

         yourDesigner.getProductDataURL(function(dataURL) {
             $.post("php/save_image.php", {
                 base64_image: dataURL
             });
         });
     });

     $('#send-image-mail-php').click(function() {

         yourDesigner.getProductDataURL(function(dataURL) {
             $.post("php/send_image_via_mail.php", {
                 base64_image: dataURL
             });
         });
     });

 }
           
           //search custom style
           function getDetailsByAttr(obj, key, val) {
            var objects = [];
            for (var i in obj) {
                if (!obj.hasOwnProperty(i))
                    continue;
                if (typeof obj[i] == 'object') {
                    objects = objects.concat(getDetailsByAttr(obj[i], key, val));
                } else if (i == key && obj[key] == val) {
                    objects.push(obj);
                }
            }
            return objects;
        }
           
            //search custom style
           function search_index(obj,  val) {
            
            for (var i=0; i<obj.length; i++) {        
              if(obj[i] == val){
                
               return i; 
            }
            }
              
            return -1;
        }
           
           
           //end search custom style
           
           
        // upload browsed image code
                             
           
           function image_upload(obj) {
                
            // $("#upload-image-loader").show();
        	//return 0;
             
             
              var total_image = get_total_image() + 1;
              if(total_image > parseInt(max_image_allowed)){
                	alert("User can not upload more than "+max_image_allowed+" images");
                return;
              }
             
                var fd = new FormData();
             var files = $(obj).parents('.image-upload-item:first').find('input[type="file"]')[0].files[0];
             
                if(!files) {
                    return;
                };
        		
             
             if(files.size/1024 > max_image_size) {
               alert("image must be less then "+ max_image_size + "kb");
               return;
             }
             
             
                  $("#upload-image-loader").show();

             
                fd.append('image', files);        

               //$image_tag.after('<div class="file-upload-loading" style="color:red">Uploading....</div>');

                $.ajax({
                    url: 'https://conceptodohaapp.com/concepto_version2/homepage/frontend_browse_image_upload',
                    type: 'post',
                    data: fd,
                    contentType: false,
                    processData: false,
                    success: function (url) {
                      //console.log("URL",url);
                       $(obj).parents('.image-upload-item:first').find('input[type="file"]').val('');

                        var element = yourDesigner.currentViewInstance.addElement("image", url, " Customer Image", {
                                        autoCenter: true, 
                                        "zChangeable": true,
                                        custom_type: "image",
                                       "removable": true,
                                      "draggable": true,
                                      "rotatable": true,
                                      "resizable": true,
                          			"topped": true,	
                          			 "copyable": false,
                                        "boundingBoxMode": "limitModify",
                                        boundingBox: boundingBoxJSON,
                          scaleX:0.2,
                          scaleY:0.2,
                                    });
                           $("#upload-image-loader").hide();
                           global_image_category = "Image Uploaded by customer";

                    },
                });
             
             
             
            }
           
           // to align the text in ver/hori
        function chunk(str, n) {
            var ret = [];
            var i;
            var len;

            for(i = 0, len = str.length; i < len; i += n) {
               ret.push(str.substr(i, n))
            }

            return ret.join("\n");
        };
           
           
           
            // function get_total_image(){
             	
            //   var custom_element = yourDesigner.getElements();
             
            //   console.log("custom_element for get_total_image() ===> ",custom_element);
              
              
              
            //   var image_layer_count = 0;
            //  for(i=1; i < custom_element.length; i++){
               
            //    console.log("title of image ==> ",custom_element[i].title);
        	//     var image_title = custom_element[i].title;
        		
        	// 	console.log("found count ==> ",image_title.toLocaleLowerCase().indexOf("strap"));
        	       

            //    if(image_title.toLocaleLowerCase().indexOf("strap") == -1)
            //    {
                 
            //    if(custom_element[i].custom_type == "image"){
            //      image_layer_count = image_layer_count+1;          
            //    }
                 
            //    }
               
            //  }
            //    return image_layer_count;
             	
            //  }

          function get_total_image(){
            var custom_element = yourDesigner.getElements();
            var image_layer_count = 0;
            var flag_layer_count = 0;

            for(i=1; i < custom_element.length; i++){
                var image_title = custom_element[i].title;
                var element_source = custom_element[i].source || '';

                // Check if this element is a flag
                var isFlag = false;
                if(flags && flags.length > 0){
                    for(var f=0; f < flags.length; f++){
                        if(flags[f].source === element_source || flags[f].title === image_title){
                            isFlag = true;
                            break;
                        }
                    }
                }
                // Fallback: check by image_category
                if(!isFlag && custom_element[i].image_category === 'Flags'){
                    isFlag = true;
                }

                // Check if this element is a strap
                var isStrap = image_title.toLocaleLowerCase().indexOf("strap") !== -1;

                if(!isStrap && !isFlag){
                    if(custom_element[i].custom_type == "image"){
                        image_layer_count = image_layer_count + 1;
                    }
                }

                if(isFlag && custom_element[i].custom_type == "image"){
                    flag_layer_count = flag_layer_count + 1;
                }
            }

            // Store flag count globally so we can check it separately
            window.current_flag_count = flag_layer_count;

            return image_layer_count;
        }
           
              
           function insert_text_html_element(obj){
               var index = obj.parents(".fpd-module:first").find(".input-container div:last").index() + 1;
                                     var html = '<div><input data-defaulttext="Enter text" name="custom-text-element'+ index +'" maxlength=10 data-index="' + index +'" placeholder="Enter Text" type="text"   class="input-text-element" /></div>';
                                    obj.parents(".fpd-module:first").find(".input-container").append(html);
           }
           
           function calculate_price(text_add = 'add'){
             	
             var custom_element = yourDesigner.getElements();
             total_price = variant_price; //parseFloat($("#variant_price").text());
             // console.log(total_price);
             var text_layer_flag = 0; var image_layer_flag = 0;
             
             //strap code start
             var matching_strap_found = false;
             var strap_price_to_add = 0;

             //console.log("=== Price Calculation Start ===");
              //console.log("Starting total_price:", total_price);
              //console.log("Looking for strap:", sstrap_name);
              //console.log("Strap price:", sstrap_price);
              //strap code end

             for(i=1; i < custom_element.length; i++){
               
               
               /* just check image title is having strap or not start*/
               var selected_image_title = custom_element[i].title;

               //strap code start
               var element_source = custom_element[i].source || '';
        
                console.log(`Element ${i}:`, {
                    title: selected_image_title,
                    source: element_source,
                    custom_type: custom_element[i].custom_type
                });
               var isStrap = false;
        
                // Method 1: Check if source matches any strap in straps_data
                if (typeof straps_data !== 'undefined' && straps_data && straps_data.length > 0) {
                    for (var j = 0; j < straps_data.length; j++) {
                        if (straps_data[j].source === element_source || 
                            straps_data[j].title === selected_image_title) {
                            isStrap = true;
                            //console.log("Identified as strap by matching straps_data");
                            break;
                        }
                    }
                }

                // Method 2: Fallback - check if title contains "strap" (case-insensitive)
                if (!isStrap && selected_image_title && 
                    selected_image_title.toLowerCase().indexOf("strap") !== -1) {
                    isStrap = true;
                    //console.log("Identified as strap by title keyword");
                }

                // If this is a strap, check if it matches sstrap_name
                if (isStrap) {
                    //console.log("Found strap element:", selected_image_title);
                    
                    // Check if the strap title matches sstrap_name (only once)
                    if (!matching_strap_found && selected_image_title === sstrap_name) {
                        matching_strap_found = true;
                        strap_price_to_add = parseFloat(sstrap_price) || 0;
                        //console.log("✓ Matching strap found! Price to add:", strap_price_to_add);
                    } else if (selected_image_title !== sstrap_name) {
                        //console.log("✗ Strap does NOT match expected name.");
                        //console.log("  Expected:", sstrap_name);
                        //console.log("  Got:", selected_image_title);
                    }
                    
                    // Don't process straps as regular images
                    continue;
                }

                // Process non-strap elements
                if (custom_element[i].custom_type == "text") {
                    // Check if text has actual content (not empty or just whitespace)
                    var text_content = custom_element[i].text || '';
                    if (text_content.trim().length > 0) {
                        text_layer_flag = 1;
                        //console.log("Text element found with content, text_price_type:", text_price_type);
                        
                        if (text_price_type == "per_char") {
                            // Accumulate character count for all text elements
                            text_char_count += text_content.length;
                            //console.log("Text content:", text_content);
                            //console.log("Text length:", text_content.length);
                            //console.log("Accumulated char count:", text_char_count);
                        }
                    } else {
                        //console.log("Text element found but content is empty - ignoring");
                    }
                } else if (custom_element[i].custom_type == "image") {
                    // Make sure it's not a strap before counting as regular image
                    image_layer_flag = 1;
                    //console.log("Image element found");
                }
                //strap code end

               /*if (selected_image_title.toLocaleLowerCase().indexOf("strap")!=-1)
               {
                 console.log("selected image is of strap");
               }
               else
               {
                 console.log("selected image is of paintings");

                 if(custom_element[i].category != "strap_images"){

                   if(custom_element[i].custom_type == "text"){
                     text_layer_flag = 1;

                     if(text_price_type == "per_char"){
                       total_price = total_price + (custom_element[i].text.length * parseFloat(text_price));           
                     }         

                   } else {
                     image_layer_flag = 1;
                     //  total_price = total_price + parseFloat(image_price);

                   }
                   console.log("In calculate_price() for function => ",custom_element[i]);

                 }

               }*/
               
               /* just check image title is having strap or not end*/

               
             }

             //strap code start
             //console.log("=== Flags Summary ===");
              //console.log("text_layer_flag:", text_layer_flag);
              //console.log("text_char_count:", text_char_count);
              //console.log("image_layer_flag:", image_layer_flag);
              //console.log("matching_strap_found:", matching_strap_found);
              //console.log("strap_price_to_add:", strap_price_to_add);

              // Calculate text price based on type
              // IMPORTANT: Text is FREE only if IMAGE is present (not strap)
              if (text_layer_flag == 1) {
                  // Only charge for text if NO image (strap doesn't make text free)
                  if (image_layer_flag == 0) {
                      if (text_price_type == "per_char") {
                          // Add price for all characters
                          var text_addition = text_char_count * parseFloat(text_price);
                          total_price = parseFloat(total_price) + text_addition;
                          //console.log("Added per-char text price:", text_addition, "(", text_char_count, "chars x", text_price, ")");
                      } else if (text_price_type == "fixed") {
                          var fixed_text_price = parseFloat(text_price) || 0;
                          total_price = parseFloat(total_price) + fixed_text_price;
                          //console.log("Added fixed text price:", fixed_text_price);
                      }
                  } else {
                      //console.log("Text is FREE (image addon present)");
                  }
              }

              // Add image price if applicable
              if (image_layer_flag == 1) {
                  var img_price = parseFloat(image_price) || 0;
                  total_price = parseFloat(total_price) + img_price;
                  //console.log("Added image price:", img_price);
              }

              // Add strap price if matching strap was found
              if (matching_strap_found && strap_price_to_add > 0) {
                  total_price = parseFloat(total_price) + strap_price_to_add;
                  //console.log("✓ Added strap price:", strap_price_to_add);
              } else if (!matching_strap_found) {
                  //console.log("✗ No matching strap found. Strap price NOT added.");
              }

              //console.log("=== Final Calculation ===");
              //console.log("Base product price:", base_price);
              //console.log("Final total_price (Product + Addons):", total_price);
              //console.log("=== Price Calculation End ===");
             
              /*if(text_price_type == "fixed"){
                if(text_layer_flag == 1 && image_layer_flag == 0 && text_add == 'add'){
                  	   total_price = total_price + parseFloat(text_price);
                }
                	
               }
        		
              if(image_layer_flag == 1){
                  	   total_price = total_price + parseFloat(image_price);
                }*/
             
               $("#final_customize_price").text(total_price.toFixed(2)); 
            
           }
           
           
           
           
             // to show and hide .mainPopup modalll
           
           
        // jQuery(window).load(function() {
        //       alert("window load occurred!");
        // });   
           

           
          
    $(document).ready(function(){
    
    // VARIANT SWITCH HANDLER
    $(document).on("click", ".Variant_switch_custom li", function() {
        
        var getUrlParameter = function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
            
            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');
                
                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
            return false;
        };
        
        var switch_variant_id = getUrlParameter('variant');
        //console.log("Variant switch:" + switch_variant_id);

        $('#ProductSelect-product-template').val(switch_variant_id).change();
        
        if (switch_variant_id) {
            get_custom_design_settings(switch_variant_id);
            updateCustomizePrice();
            
            // If customizer modal is open, reload it with new variant
            if ($(".mainPopup").is(':visible')) {
                reloadCustomizerWithVariant(switch_variant_id);
            }
        } else {
            var currentVar = getCurrentVariantId();
            if (currentVar) {
                get_custom_design_settings(currentVar);
                updateCustomizePrice();
                
                // If customizer modal is open, reload it with new variant
                if ($(".mainPopup").is(':visible')) {
                    reloadCustomizerWithVariant(currentVar);
                }
            }
        }
    });
    
    });
            
    // to store customize image to show in cart 
    $(document).ready(function(){   

        // Dynamically-detected variant option names (e.g. "Color", "Strap
        // Belt" for one product, "iPhone Size", "Frame Color" for
        // another). Populated fresh by collectProperties() on every
        // call — never hardcoded, since every product's variant options
        // are different. Declared here at the top of this closure so
        // every nested handler (collectProperties, checkout button
        // click, ajax callbacks) can reliably read/write it.
        var lastDetectedOptionNames = [];

        //checkout button with getProduct()
        $('.mainPopup').on('click', '#checkout-button', function(e){ 
            var product = yourDesigner.getProduct();
            // alert(yourDesigner); 
            product.extra_note = $('#extra-note').val();
            var note = $('#extra-note').val();
            //console.log(product);
            // 	console.log("note",note);
            
            // return 0;

            $("#custom-settings-loader").show();
            $("#checkout-button").prop('disabled','disabled');
            $(".setting_checkout").show();
            $('.customize-action-button').css("pointer-events","none")                  
                            //	return 0;

            
            var draft_variant_id = null;

            /* ============================================================
               FIX: read the CURRENTLY SELECTED variant via
               getCurrentVariantId()'s existing fallback chain (URL param
               -> .product-variant-id hidden input -> form input[name="id"]
               -> checked input/select) instead of the old
               #ProductSelect-product-template dropdown, which doesn't
               exist on templates that hide variant-selects and use a
               hidden input instead. This is the exact same class of fix
               already applied elsewhere in this file (see "GET INITIAL
               VARIANT ID" and the ".customizer_button" click handler
               above) — it was just missed in this one spot.
               ============================================================ */
            var variant_id = getCurrentVariantId();
            //console.log('variant id edreamz',variant_id);
            
            yourDesigner.getProductDataURL(function (dataURL) {
                $.ajax({
                    url: 'https://conceptodohaapp.com/concepto_version2/homepage/frontend_customize_image_upload_for_cart',
                    // url: 'https://webdevfolio.com/shopifyapps/Concepto-version2/homepage/frontend_customize_image_upload_for_cart',
                    type: 'post',
                    // FIX: JSON body (passes server WAF; no fetch/Blob which froze the page)
                    data: JSON.stringify({base64_image: dataURL, customize_settings: product}),
                    contentType: 'application/json; charset=UTF-8',
                    cache: false,
                    dataType: 'json',
                    success: function (response) {
                            //console.log(response.preview_image);
                            //console.log(response);     
                            //console.log("nik innn1");    
                        // now add product to cart
                    //  return 0;
                    var product_title = $(".get_product_title").text();
                    // var product_title = "";
                    //var variant_title = $("#ProductSelect-product-template option:selected").html();
                    var variant_title = getCurrentVariantTitle();
                    //console.log('variant title edreamz',variant_title);
                    var product_customize_image = response.preview_image;    
                    var customize_image_file_path = response.prev_file_path;        
                        //console.log("product_title-"+product_title+" | variant_title-"+variant_title);
                        // return 0;

                    
                    var total_customize_price = $("#final_customize_price").text();    
                        
                    //   alert(total_customize_price);
                        
                        // create draft product with final price and title start
                    $.ajax({
                        url: 'https://conceptodohaapp.com/concepto_version2/homepage/create_draftproduct_for_addtocart',
                        type: 'post',
                        dataType: 'json',
                        cache: false,
                        crossDomain: true,                                
                        data: {
                            product_title: product_title, 
                            variant_title: variant_title,
                            total_customize_price: total_customize_price,
                            product_customize_image: product_customize_image,
                            customize_image_file_path: customize_image_file_path,
                            properties_data: JSON.stringify(collectProperties())  // NEW: Send properties to backend
                        },
                        success: function (response_draft) {
                            //console.log("Draft product created successfully");
                            //console.log("Response:", response_draft);
                            //console.log("Variant ID:", response_draft.variants[0].id);
                            
                            if (response_draft && response_draft.variants && response_draft.variants[0]) {
                                
                                draft_variant_id = response_draft.variants[0].id;
                                //console.log("Draft Variant ID:", draft_variant_id);
                                
                                // ============================================================
                                // NEW: GET HIDDEN PROPERTIES FROM RESPONSE
                                // ============================================================
                                var hiddenProperties = response_draft.hidden_properties || {};
                                
                                //console.log("Hidden properties from backend:", hiddenProperties);

                                // FIX: the remote backend (conceptodohaapp.com) prefixes some
                                // property keys with "_" (e.g. "_Color", "_Strap Belt", or
                                // "_iPhone Size" / "_Frame Color" for a different product), and
                                // Shopify hides any underscore-prefixed property from cart
                                // display. We want the variant option properties to stay
                                // VISIBLE, so strip the leading underscore for exactly the
                                // option names we dynamically detected for THIS product
                                // (never a hardcoded list — every product's options differ).
                                var keysToUnhide = lastDetectedOptionNames.length > 0 ? lastDetectedOptionNames : [];
                                keysToUnhide.forEach(function(key) {
                                    var hiddenKey = '_' + key;
                                    if (Object.prototype.hasOwnProperty.call(hiddenProperties, hiddenKey)) {
                                        hiddenProperties[key] = hiddenProperties[hiddenKey];
                                        delete hiddenProperties[hiddenKey];
                                    }
                                });
                                //console.log("Properties after un-hiding variant options:", hiddenProperties);
                                
                                var innerColorEl = document.getElementById('Inner-color');
                                if (innerColorEl && innerColorEl.value.trim() !== '') {
                                    hiddenProperties['Inner Color'] = innerColorEl.value.trim();
                                }

                                var stitchingColorEl = document.getElementById('stitching-color');
                                if (stitchingColorEl && stitchingColorEl.value.trim() !== '') {
                                    hiddenProperties['Stitching Color'] = stitchingColorEl.value.trim();
                                }

                                var stitchingColorNewEl = document.getElementById('stitching-color-new');
                                var stitchingCheckbox = document.getElementById('showStitchingColorCheckbox');
                                if (stitchingCheckbox && stitchingCheckbox.checked && 
                                    stitchingColorNewEl && stitchingColorNewEl.value.trim() !== '') {
                                    hiddenProperties['Stitching Color'] = stitchingColorNewEl.value.trim();
                                }

                                /* ============================================================
                                   NEW TEMPLATE (buy-buttons.liquid, product tag
                                   'custom-options'): Wallet color -> real Shopify variant,
                                   shown via #swtLeatherCurrent; Crocodile Leather Belt ->
                                   custom line-item property, value stored in hidden input
                                   #swtCrocInput. Purely additive — only fires when those
                                   specific elements exist in the DOM, so every other
                                   template/product is completely unaffected.
                                   ============================================================ */
                                var walletColorEl = document.getElementById('swtLeatherCurrent');
                                if (walletColorEl && walletColorEl.textContent.trim() !== '') {
                                    hiddenProperties['Wallet color'] = walletColorEl.textContent.trim();
                                }

                                var crocBeltEl = document.getElementById('swtCrocInput');
                                if (crocBeltEl && crocBeltEl.value.trim() !== '') {
                                    hiddenProperties['Crocodile Leather Belt'] = crocBeltEl.value.trim();
                                }

                                //console.log("Final cart properties:", hiddenProperties);
                                
                                // ============================================================
                                // ADD TO CART WITH HIDDEN PROPERTIES
                                // ============================================================
                                /* FIX: window.cartAddUrl is not defined on every template
                                   (e.g. the "custom-dropdown" bespoke wallet template) —
                                   when it's missing, "window.cartAddUrl + '.js'" becomes the
                                   literal string "undefined.js", the POST 404s, and the
                                   .fail() handler below fires "Error adding product to cart.
                                   Please try again." Resolve the URL safely instead: prefer
                                   window.cartAddUrl when it IS defined (so templates that
                                   already rely on it keep working unchanged), otherwise fall
                                   back to Shopify's own routes.cart_add_url, otherwise the
                                   always-valid /cart/add. */
                                var cartAddUrl = window.cartAddUrl
                                    || (typeof routes !== 'undefined' && routes.cart_add_url)
                                    || '/cart/add';
                                //console.log("Resolved cart add URL:", cartAddUrl);
                                $.post(cartAddUrl + '.js', { 
                                    quantity: 1, 
                                    id: draft_variant_id, 
                                    properties: hiddenProperties
                                }, null, "json") 
                                    .done(function (data, status) { 
                                        //console.log("âœ“ cart/add.js DONE status:", status); 
                                        //console.log("âœ“ cart/add.js response:", data); 
                                        //console.log("âœ“ Added to cart with hidden properties");
                                        //console.log("âœ“ Line item properties:", data.properties);
                                        
                                        // Verify properties in cart
                                        $.get("/cart.js", function(cart) {
                                            //console.log("âœ“ Current cart:", cart);
                                            if (cart.items && cart.items.length > 0) {
                                                //console.log("âœ“ Last item properties:", cart.items[cart.items.length - 1].properties);
                                            }
                                        });
                                        
                                        // Redirect to cart after short delay
                                        setTimeout(function() {
                                            window.location.replace("/cart"); 
                                        }, 500);
                                    }) 
                                    .fail(function (xhr, status, error) { 
                                        console.error("âœ— cart/add.js FAILED status:", status); 
                                        console.error("âœ— cart/add.js error:", error); 
                                        console.error("âœ— cart/add.js responseText:", xhr.responseText); 
                                        
                                        // Show error to user
                                        alert("Error adding product to cart. Please try again.");
                                    }); 
                            } 
                            else {
                                console.error("Invalid response from server");
                                alert("Error creating product. Please try again.");
                            }

                            
                        },
                        error: function (xhr, status, error) {
                        
                            alert("Error creating draft product. Please try again.");
                        }
                        });

                        // ============================================================
                        // HELPER FUNCTION: Collect all properties
                        // ============================================================

                        // function collectProperties() {
                        //     var properties = {};
                            
                        //     // Original Image
                        //     //properties['Original Image'] = product[0]['thumbnail'] || '';
                            
                        //     // Image On case
                        //     //properties['Image On case'] = '2';
                            
                        //     // Collect text and image elements
                        //     for (var i = 0; i < product[0]['elements'].length; i++) {
                        //         if (product[0]['elements'][i]['type'] == 'text') {
                        //             // Text properties
                        //             properties['Text'] = $("input[name=custom-text-element_1]").val() || '';
                        //             properties['Font Family'] = product[0]['elements'][i]['parameters']['fontFamily'] || '';
                        //             properties['Font Size'] = product[0]['elements'][i]['parameters']['fontSize'] || '';
                        //             properties['Text Color Code'] = product[0]['elements'][i]['parameters']['fill'] || '';
                        //             properties['Text Border Color Code'] = product[0]['elements'][i]['parameters']['shadowColor'] || '';
                        //             properties['Text Alignment'] = product[0]['elements'][i]['parameters']['custom_text_allignment'] || '';
                        //         } 
                        //         else {
                        //             // Image properties
                        //             //properties['Image Name'] = product[0]['elements'][i]['title'] || '';
                        //             properties['Image Source'] = product[0]['elements'][i]['source'] || '';
                        //         }
                        //     }
                            
                        //     // Additional properties
                        //     properties['preview_image'] = response.preview_image || '';
                        //     properties['Total Price'] = total_customize_price || '';
                        //     //properties['note'] = note || '';
                        //     properties['base_variant_id'] = variant_id || '';
                        //     properties['Size'] = getCurrentVariantTitle() || '';
                            
                        //     return properties;
                        // }
                        

                        function collectProperties() {
                            var properties = {};
                            
                            // ============================================================
                            // DEBUG — remove after confirming
                            // ============================================================
                            //console.log("=== collectProperties DEBUG ===");
                            
                            // Check all variant selects on page
                            document.querySelectorAll('variant-selects').forEach(function(el, i) {
                                //console.log("variant-selects[" + i + "] data-sticky:", el.getAttribute('data-sticky'));
                                el.querySelectorAll('select.select__select').forEach(function(sel, j) {
                                    console.log("  select[" + j + "] value:", sel.value);
                                });
                            });
                            
                            // Check for single-variant (hidden input)
                            var hiddenVariantInput = document.querySelector('input.product-variant-id');
                            //console.log("Hidden variant input:", hiddenVariantInput ? hiddenVariantInput.value : "NOT FOUND");
                            
                            // Check Inner-color
                            var innerEl = document.getElementById('Inner-color');
                            //console.log("Inner-color element:", innerEl ? "FOUND, value='" + innerEl.value + "'" : "NOT FOUND");
                            
                            // Check stitching-color
                            var stitchEl = document.getElementById('stitching-color');
                            //console.log("stitching-color element:", stitchEl ? "FOUND, value='" + stitchEl.value + "'" : "NOT FOUND");
                            
                            var stitchNewEl = document.getElementById('stitching-color-new');
                            //console.log("stitching-color-new element:", stitchNewEl ? "FOUND, value='" + stitchNewEl.value + "'" : "NOT FOUND");
                            
                            //console.log("=== END DEBUG ===");
                            // ============================================================

                            // Collect text and image elements
                            for (var i = 0; i < product[0]['elements'].length; i++) {
                                if (product[0]['elements'][i]['type'] == 'text') {
                                    properties['Text'] = $("input[name=custom-text-element_1]").val() || '';
                                    properties['Font Family'] = product[0]['elements'][i]['parameters']['fontFamily'] || '';
                                    properties['Font Size'] = product[0]['elements'][i]['parameters']['fontSize'] || '';
                                    properties['Text Color Code'] = product[0]['elements'][i]['parameters']['fill'] || '';
                                    properties['Text Border Color Code'] = product[0]['elements'][i]['parameters']['shadowColor'] || '';
                                    properties['Text Alignment'] = product[0]['elements'][i]['parameters']['custom_text_allignment'] || '';
                                } else {
                                    properties['Image Source'] = product[0]['elements'][i]['source'] || '';
                                }
                            }

                            /* ============================================================
                               FIX: on the "custom-dropdown" template (buy-buttons.liquid,
                               product tag 'custom-options' — recognizable by its
                               .swt-custom-options wrapper), the real Shopify variant option
                               is literally named "Wallet Color". The generic variant-option
                               detector below (used for every other product) would read that
                               option's title at the moment collectProperties() runs and add
                               its own "Wallet Color" property — but on this template that
                               read lags behind the swatch click, so it captures the STALE
                               value (e.g. "Tan") while the dedicated #swtLeatherCurrent
                               block further down correctly captures the CURRENT value (e.g.
                               "Black"). The two ended up as separate properties (different
                               casing) and both showed in the cart. Skip the generic
                               detector entirely on this template — the dedicated
                               "Wallet color" / "Crocodile Leather Belt" blocks below already
                               cover both of this template's options. Every other template
                               (no .swt-custom-options element) is unaffected and keeps using
                               the generic detector exactly as before.
                               ============================================================ */
                            var isSwtCustomOptionsTemplate = !!document.querySelector('.swt-custom-options');

                            // FIX: assign each variant option (Color, Strap Belt, etc.) as its own
                            // separate property, using the full variant title split by ' / '.
                            var currentVariantId = getCurrentVariantId();
                            var fullTitle = '';
                            //console.log('[SizeFix] currentVariantId:', currentVariantId);

                            // Method 1: look up the full title from any embedded variant JSON
                            // (works no matter how the option pickers are rendered).
                            (function() {
                                if (!currentVariantId) return;
                                var scripts = document.querySelectorAll('script[type="application/json"]');
                                for (var s = 0; s < scripts.length; s++) {
                                    try {
                                        var data = JSON.parse(scripts[s].textContent);
                                        if (Array.isArray(data)) {
                                            for (var v = 0; v < data.length; v++) {
                                                if (data[v] && String(data[v].id) === String(currentVariantId) && data[v].title) {
                                                    fullTitle = data[v].title;
                                                    return;
                                                }
                                            }
                                        }
                                    } catch (e) { /* ignore non-variant JSON blocks */ }
                                }
                            })();
                            //console.log('[SizeFix] fullTitle after JSON lookup:', fullTitle);

                            // Method 2: rebuild from DOM — cast a wide net across common
                            // Shopify markup patterns (custom element, fieldsets, radios, selects).
                            var optionNames = [];
                            var optionValues = [];

                            // Helper: Shopify select/fieldset "name" attributes are sometimes in
                            // the form "options[Strap Belt]" — extract the clean option name.
                            function cleanOptionName(raw) {
                                if (!raw) return raw;
                                var m = raw.match(/options\[(.+)\]/i);
                                if (m) return m[1].trim();
                                return raw.trim();
                            }

                            // FIX: skip all generic detection (JSON lookup already ran above,
                            // so clear it here) on the custom-dropdown template — the
                            // dedicated Wallet color / Crocodile Leather Belt blocks below
                            // are the single source of truth for this template's options.
                            if (isSwtCustomOptionsTemplate) {
                                fullTitle = '';
                            }

                            if (!fullTitle && !isSwtCustomOptionsTemplate) {
                                var containers = [];
                                var vs = document.querySelector('variant-selects');
                                if (vs) containers.push(vs);
                                document.querySelectorAll('form[action*="/cart/add"]').forEach(function(f) { containers.push(f); });
                                if (containers.length === 0) containers.push(document);

                                containers.forEach(function(container) {
                                    if (optionValues.length > 0) return; // already found one
                                    var fieldsets = container.querySelectorAll('fieldset');
                                    fieldsets.forEach(function(fieldset) {
                                        var name = fieldset.getAttribute('name');
                                        if (!name) {
                                            var legend = fieldset.querySelector('legend');
                                            if (legend) name = legend.textContent.split(':')[0].trim();
                                        }
                                        name = cleanOptionName(name);
                                        var select = fieldset.querySelector('select');
                                        var value = null;
                                        if (select) {
                                            var opt = select.options[select.selectedIndex];
                                            value = opt ? opt.value : null;
                                        } else {
                                            var checked = fieldset.querySelector('input[type="radio"]:checked');
                                            value = checked ? checked.value : null;
                                        }
                                        if (name && value) {
                                            optionNames.push(name);
                                            optionValues.push(value);
                                        }
                                    });

                                    // Also capture any <select> elements NOT wrapped in a fieldset
                                    // (e.g. Strap Belt, which is a plain <select> with no fieldset).
                                    container.querySelectorAll('select').forEach(function(select) {
                                        if (select.closest('fieldset')) return; // already handled above
                                        var name = cleanOptionName(select.getAttribute('name'));
                                        var opt = select.options[select.selectedIndex];
                                        if (name && opt && opt.value) {
                                            optionNames.push(name);
                                            optionValues.push(opt.value);
                                        }
                                    });

                                    // No fieldsets found — try loose selects / checked radios directly
                                    if (optionValues.length === 0) {
                                        container.querySelectorAll('select[name]').forEach(function(select) {
                                            var opt = select.options[select.selectedIndex];
                                            if (opt && opt.value) {
                                                optionNames.push(cleanOptionName(select.getAttribute('name')));
                                                optionValues.push(opt.value);
                                            }
                                        });
                                        container.querySelectorAll('input[type="radio"][name]:checked').forEach(function(input) {
                                            optionNames.push(cleanOptionName(input.getAttribute('name')));
                                            optionValues.push(input.value);
                                        });
                                    }
                                });

                                fullTitle = optionValues.join(' / ');
                                //console.log('[SizeFix] optionNames from DOM:', optionNames);
                                //console.log('[SizeFix] fullTitle after DOM fallback:', fullTitle);
                            }

                            // Method 3: last resort (skip on the custom-dropdown template —
                            // its options are handled solely by the dedicated blocks below)
                            if (!fullTitle && !isSwtCustomOptionsTemplate) {
                                fullTitle = getCurrentVariantTitle();
                                //console.log('[SizeFix] fullTitle from getCurrentVariantTitle():', fullTitle);
                            }

                            // Shopify gives single-variant products (no real options) the
                            // literal title "Default Title" — treat that the same as empty,
                            // since there's no real variant info to show.
                            if (fullTitle && fullTitle.trim().toLowerCase() === 'default title') {
                                fullTitle = '';
                            }

                            // Generic fallback labels ONLY used if we truly couldn't detect any
                            // real option names from the DOM — never hardcode a specific
                            // product's option names (e.g. "Color"/"Strap Belt"), since every
                            // product has different variant options.
                            if (optionNames.length === 0) {
                                optionNames = ['Option 1', 'Option 2', 'Option 3'];
                            }

                            var usedOptionNames = [];
                            if (isSwtCustomOptionsTemplate) {
                                // Custom-dropdown template: the dedicated "Wallet color" /
                                // "Crocodile Leather Belt" blocks further down are the only
                                // source for this template's option properties — nothing to
                                // do here, and nothing to un-hide later.
                                //console.log('[SizeFix] Custom-dropdown template detected — generic variant-option detection skipped.');
                            } else if (fullTitle) {
                                var parts = fullTitle.split(' / ');
                                parts.forEach(function(part, index) {
                                    var label = optionNames[index] || ('Option ' + (index + 1));
                                    properties[label] = part.trim();
                                    usedOptionNames.push(label);
                                });
                            } else {
                                // No real variant options on this product (e.g. AirPods case
                                // with no Color/Size choices) — don't add a fake "Size:
                                // Default" property. A product with no options shows nothing
                                // extra, exactly like a normal (non-customized) Add to Cart.
                                //console.log('[SizeFix] No real variant options detected — skipping Size/Color property entirely.');
                            }

                            // Remember exactly which property keys hold variant option values
                            // this time, so the Add to Cart handler can un-hide the matching
                            // backend-returned properties later — dynamically, per product.
                            lastDetectedOptionNames = usedOptionNames;

                            //console.log('[SizeFix] final properties:', properties);

                            // Inner Color
                            var innerColorEl = document.getElementById('Inner-color');
                            if (innerColorEl && innerColorEl.value.trim() !== '') {
                                properties['Inner Color'] = innerColorEl.value.trim();
                            }

                            // Stitching Color (tag: stiching-color)
                            var stitchingColorEl = document.getElementById('stitching-color');
                            if (stitchingColorEl && stitchingColorEl.value.trim() !== '') {
                                properties['StitchingColor'] = stitchingColorEl.value.trim();
                            }

                            // Stitching Color (tag: change-stitching-color, checkbox-gated)
                            var stitchingColorNewEl = document.getElementById('stitching-color-new');
                            var stitchingCheckbox = document.getElementById('showStitchingColorCheckbox');
                            if (stitchingCheckbox && stitchingCheckbox.checked && stitchingColorNewEl && stitchingColorNewEl.value.trim() !== '') {
                                properties['stitchingcolor'] = stitchingColorNewEl.value.trim();
                            }

                            /* ============================================================
                               NEW TEMPLATE (buy-buttons.liquid, product tag
                               'custom-options'): Wallet color -> real Shopify variant swatch,
                               label shown in #swtLeatherCurrent; Crocodile Leather Belt ->
                               custom line-item property, value in hidden input
                               #swtCrocInput. Purely additive, only fires when those specific
                               elements exist on this page — every other template is
                               unaffected.
                               ============================================================ */
                            var walletColorEl = document.getElementById('swtLeatherCurrent');
                            if (walletColorEl && walletColorEl.textContent.trim() !== '') {
                                properties['Wallet color'] = walletColorEl.textContent.trim();
                            }

                            var crocBeltEl = document.getElementById('swtCrocInput');
                            if (crocBeltEl && crocBeltEl.value.trim() !== '') {
                                properties['Crocodile Leather Belt'] = crocBeltEl.value.trim();
                            }

                            // Additional properties
                            properties['preview_image'] = response.preview_image || '';
                            properties['Total Price'] = total_customize_price || '';
                            properties['base_variant_id'] = variant_id || '';
                            
                            //console.log("Final properties:", properties);
                            
                            return properties;
                        }

                                                                                                                                
                    },
                    // FIX: without this the loader spun forever when the upload failed
                    error: function (xhr, status, err) {
                        console.error('Image upload failed -> status:', xhr.status, '| state:', status, '| err:', err,
                                      '| payload size (KB):', Math.round((dataURL || '').length / 1024), '| response:', xhr.responseText);
                        $('#custom-settings-loader').hide();
                        $('.setting_checkout').hide();
                        $('#checkout-button').prop('disabled', false);
                        $('.customize-action-button').css('pointer-events', 'auto');
                        alert('Design upload failed. Please try again.');
                    }
                    });
                });
            return false;
        }); 
    });

function editormode_chk(){
    if(editor_mode_hide && editor_mode_hide.indexOf('painting') !== -1){  // false → -1
        return true;
    } 
    return false;
}

function editormode_chk121(){
    if(editor_mode_hide && editor_mode_hide.indexOf('flags') !== -1){  // false → -1
        return true;
    } 
    return false;
}

function editormode_chk1(){
    if(file_uploade_hide && file_uploade_hide.indexOf('hide') !== -1){  // false → -1
        jQuery('.custom-image-upload').remove();
        $('.image-upload-item').css("display","none");
        return true;
    } 
    return false;
}
        
// ============================================================
// CHECK INVENTORY FOR SPECIFIC LOCATION: 14377418819
// Proxied through your existing backend to avoid token exposure
// ============================================================

var TARGET_LOCATION_ID = "14377418819";

// ============================================================
// ADD THIS — debounce timer at top of your file with other vars
// ============================================================
var inventoryCheckTimer = null;
var inventoryCheckSeq = 0; // latest-request guard (stale response ignore karne ke liye)

function checkLocationInventoryAndShowButton(variantId) {
    if (!variantId) {
        $(".customizer_button").hide();
        $(".custom_buy_now_btn").hide();
        return;
    }

    // DEBOUNCE
    if (inventoryCheckTimer) {
        clearTimeout(inventoryCheckTimer);
    }

    var currentSeq = ++inventoryCheckSeq;

    inventoryCheckTimer = setTimeout(function() {

        $.ajax({
            url: "https://conceptodohaapp.com/concepto_version2/homepage/check_location_inventory",
            type: "POST",
            crossDomain: true,
            cache: false,
            dataType: "json",
            data: {
                variant_id: String(variantId),
                location_id: TARGET_LOCATION_ID
            },
            success: function(response) {
                // Purana response (pehle select kiye variant ka) ignore karo
                if (currentSeq !== inventoryCheckSeq) {
                    //console.log("Stale inventory response ignored for variant", variantId);
                    return;
                }

                //console.log("Location inventory response:", response, "for variant", variantId);

                // backend true / "true" / 1 / qty>0 kuch bhi bheje, sab handle ho
                var qty = response ? parseInt(response.qty, 10) : 0;
                var isAvailable = !!response && (
                    response.available === true ||
                    response.available === "true" ||
                    response.available === 1 ||
                    response.available === "1" ||
                    qty > 0
                );

                if (isAvailable) {
                    //console.log("In stock at location", TARGET_LOCATION_ID, "qty:", qty, "-> Showing button");
                    $(".customizer_button").show();
                    $(".custom_buy_now_btn").show();

                    if ($(".price--sold-out").length > 0) {
                        $(".customizer_button").hide();
                        $(".custom_buy_now_btn").hide();
                    }
                } else {
                    //console.log("Out of stock at location", TARGET_LOCATION_ID, "(variant", variantId + ", qty:", qty + ") -> Hiding button");
                    $(".customizer_button").hide();
                    $(".custom_buy_now_btn").hide();
                }
            },
            error: function(xhr, status, error) {
                if (currentSeq !== inventoryCheckSeq) return;
                //console.error("Inventory check failed:", status, error, xhr && xhr.responseText);
                $(".customizer_button").hide();
                $(".custom_buy_now_btn").hide();
            }
        });

    }, 400); // ✅ Only fires once even if called 10 times within 400ms
}